/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
(window.theme = window.theme || {}),
    (window.Shopify = window.Shopify || {}),
    (theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: 769px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!(
            "ontouchstart" in window ||
            (window.DocumentTouch && window.document instanceof DocumentTouch) ||
            window.navigator.maxTouchPoints ||
            window.navigator.msMaxTouchPoints
        ),
        stickyHeader: !1,
        rtl: "rtl" == document.documentElement.getAttribute("dir"),
    }),
    theme.config.isTouch && (document.documentElement.className += " supports-touch"),
    console &&
        console.log &&
        console.log(
            "Impulse theme (" +
                theme.settings.themeVersion +
                ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
        ),
    (theme.recentlyViewed = { recent: {}, productInfo: {} }),
    (function () {
        "use strict";
        var e, t, i, s, n, o, a, r, c;
        (theme.delegate = {
            on: function (e, t, i) {
                return (
                    this.namespaces || (this.namespaces = {}),
                    (this.namespaces[e] = t),
                    (i = i || !1),
                    this.addEventListener(e.split(".")[0], t, i),
                    this
                );
            },
            off: function (e) {
                if (this.namespaces)
                    return (
                        this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e], this
                    );
            },
        }),
            (window.on = Element.prototype.on = theme.delegate.on),
            (window.off = Element.prototype.off = theme.delegate.off),
            (theme.utils = {
                defaultTo: function (e, t) {
                    return null == e || e != e ? t : e;
                },
                wrap: function (e, t) {
                    e.parentNode.insertBefore(t, e), t.appendChild(e);
                },
                debounce: function (e, t, i) {
                    var s;
                    return function () {
                        var n = this,
                            o = arguments,
                            a = i && !s;
                        clearTimeout(s),
                            (s = setTimeout(function () {
                                (s = null), i || t.apply(n, o);
                            }, e)),
                            a && t.apply(n, o);
                    };
                },
                throttle: function (e, t) {
                    var i = !1;
                    return function () {
                        i ||
                            (t.apply(this, arguments),
                            (i = !0),
                            setTimeout(function () {
                                i = !1;
                            }, e));
                    };
                },
                prepareTransition: function (e, t) {
                    e.addEventListener("transitionend", function t(i) {
                        e.classList.remove("is-transitioning"), e.removeEventListener("transitionend", t);
                    }),
                        e.classList.add("is-transitioning"),
                        e.offsetWidth,
                        "function" == typeof t && t();
                },
                compact: function (e) {
                    for (var t = -1, i = null == e ? 0 : e.length, s = 0, n = []; ++t < i; ) {
                        var o = e[t];
                        o && (n[s++] = o);
                    }
                    return n;
                },
                serialize: function (e) {
                    var t = [];
                    return (
                        Array.prototype.slice.call(e.elements).forEach(function (e) {
                            !e.name ||
                                e.disabled ||
                                ["file", "reset", "submit", "button"].indexOf(e.type) > -1 ||
                                ("select-multiple" !== e.type
                                    ? (["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked) ||
                                      t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value))
                                    : Array.prototype.slice.call(e.options).forEach(function (i) {
                                          i.selected &&
                                              t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(i.value));
                                      }));
                        }),
                        t.join("&")
                    );
                },
            }),
            (theme.a11y = {
                trapFocus: function (e) {
                    var t = {
                            focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                            focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                            keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus",
                        },
                        i = e.container.querySelectorAll(
                            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
                        ),
                        s = [].slice.call(i).filter((e) => null !== e.offsetParent),
                        n = s[0],
                        o = s[s.length - 1];
                    e.elementToFocus || (e.elementToFocus = e.container),
                        e.container.setAttribute("tabindex", "-1"),
                        e.elementToFocus.focus(),
                        document.documentElement.off("focusin"),
                        document.documentElement.on(t.focusout, function () {
                            document.documentElement.off(t.keydown);
                        }),
                        document.documentElement.on(t.focusin, function (i) {
                            (i.target !== e.container && i.target !== o && i.target !== n) ||
                                document.documentElement.on(t.keydown, function (e) {
                                    !(function (e) {
                                        if (9 !== e.keyCode) return;
                                        e.target !== o || e.shiftKey || (e.preventDefault(), n.focus());
                                    })(e);
                                });
                        });
                },
                removeTrapFocus: function (e) {
                    var t = e.namespace ? "focusin." + e.namespace : "focusin";
                    e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t);
                },
                lockMobileScrolling: function (e, t) {
                    var i = t || document.documentElement;
                    document.documentElement.classList.add("lock-scroll"),
                        i.on("touchmove" + e, function () {
                            return !0;
                        });
                },
                unlockMobileScrolling: function (e, t) {
                    document.documentElement.classList.remove("lock-scroll"),
                        (t || document.documentElement).off("touchmove" + e);
                },
            }),
            document.documentElement.on("keyup.tab", function (e) {
                9 === e.keyCode &&
                    (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"));
            }),
            (theme.Currency =
                ((e = theme && theme.settings && theme.settings.superScriptPrice),
                {
                    formatMoney: function (t, i) {
                        i || (i = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
                        var s = "",
                            n = /\{\{\s*(\w+)\s*\}\}/,
                            o = i || "${{amount}}";
                        function a(e, t, i, s) {
                            if (
                                ((t = theme.utils.defaultTo(t, 2)),
                                (i = theme.utils.defaultTo(i, ",")),
                                (s = theme.utils.defaultTo(s, ".")),
                                isNaN(e) || null == e)
                            )
                                return 0;
                            var n = (e = (e / 100).toFixed(t)).split(".");
                            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "");
                        }
                        switch (o.match(n)[1]) {
                            case "amount":
                                (s = a(t, 2)), e && s && s.includes(".") && (s = s.replace(".", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals":
                                s = a(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                (s = a(t, 2, ".", ",")),
                                    e && s && s.includes(",") && (s = s.replace(",", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                s = a(t, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                s = a(t, 0, " ");
                        }
                        return o.replace(n, s);
                    },
                    getBaseUnit: function (e) {
                        if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value)
                            return 1 === e.unit_price_measurement.reference_value
                                ? e.unit_price_measurement.reference_unit
                                : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                    },
                })),
            (theme.Images = {
                imageSize: function (e) {
                    if (!e) return "620x";
                    var t = e.match(
                        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
                    );
                    return null !== t ? t[1] : null;
                },
                getSizedImageUrl: function (e, t) {
                    if (!e) return e;
                    if (null == t) return e;
                    if ("master" === t) return this.removeProtocol(e);
                    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != i) {
                        var s = e.split(i[0]),
                            n = i[0];
                        return this.removeProtocol(s[0] + "_" + t + n);
                    }
                    return null;
                },
                removeProtocol: function (e) {
                    return e.replace(/http(s)?:/, "");
                },
                buildImagePath: function (e, t) {
                    if (null == e) return [];
                    if (t) {
                        const i = [];
                        return (
                            t.forEach((s) => {
                                let n = `${e}?width=${s}`;
                                s === t[t.length - 1] ? (n += ` ${s}w`) : (n += ` ${s}w,`), i.push(n);
                            }),
                            i
                        );
                    }
                    return [e];
                },
            }),
            (theme.initWhenVisible = function (e) {
                var t = e.threshold ? e.threshold : 0;
                new IntersectionObserver(
                    (t, i) => {
                        t.forEach((t) => {
                            t.isIntersecting &&
                                "function" == typeof e.callback &&
                                (e.callback(), i.unobserve(t.target));
                        });
                    },
                    { rootMargin: "0px 0px " + t + "px 0px" }
                ).observe(e.element);
            }),
            (theme.LibraryLoader =
                ((s = { requested: "requested", loaded: "loaded" }),
                (o = {
                    youtubeSdk: {
                        tagId: "youtube-sdk",
                        src: "https://www.youtube.com/iframe_api",
                        type: (i = "script"),
                    },
                    vimeo: { tagId: "vimeo-api", src: "https://player.vimeo.com/api/player.js", type: i },
                    shopifyXr: {
                        tagId: "shopify-model-viewer-xr",
                        src:
                            (n = "https://cdn.shopify.com/shopifycloud/") +
                            "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                        type: i,
                    },
                    modelViewerUi: {
                        tagId: "shopify-model-viewer-ui",
                        src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                        type: i,
                    },
                    modelViewerUiStyles: {
                        tagId: "shopify-model-viewer-ui-styles",
                        src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                        type: (t = "link"),
                    },
                }),
                {
                    load: function (e, n) {
                        var a = o[e];
                        if (a && a.status !== s.requested)
                            if (((n = n || function () {}), a.status !== s.loaded)) {
                                var r;
                                switch (((a.status = s.requested), a.type)) {
                                    case i:
                                        r = (function (e, t) {
                                            var i = document.createElement("script");
                                            return (
                                                (i.src = e.src),
                                                i.addEventListener("load", function () {
                                                    (e.status = s.loaded), t();
                                                }),
                                                i
                                            );
                                        })(a, n);
                                        break;
                                    case t:
                                        r = (function (e, t) {
                                            var i = document.createElement("link");
                                            return (
                                                (i.href = e.src),
                                                (i.rel = "stylesheet"),
                                                (i.type = "text/css"),
                                                i.addEventListener("load", function () {
                                                    (e.status = s.loaded), t();
                                                }),
                                                i
                                            );
                                        })(a, n);
                                }
                                (r.id = a.tagId), (a.element = r);
                                var c = document.getElementsByTagName(a.type)[0];
                                c.parentNode.insertBefore(r, c);
                            } else n();
                    },
                })),
            (theme.rteInit = function () {
                function e(e) {
                    e.src = e.src;
                    var t = document.createElement("div");
                    t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
                }
                document.querySelectorAll(".rte table").forEach((e) => {
                    var t = document.createElement("div");
                    t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
                }),
                    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll(".rte a img").forEach((e) => {
                        e.parentNode.classList.add("rte__image");
                    });
            }),
            (theme.Sections = function () {
                (this.constructors = {}),
                    (this.instances = []),
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                    document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
                _createInstance: function (e, t, i) {
                    var s = e.getAttribute("data-section-id"),
                        n = e.getAttribute("data-section-type");
                    if (void 0 !== (t = t || this.constructors[n])) {
                        if (i) this._findInstance(s) && this._removeInstance(s);
                        try {
                            var o = Object.assign(new t(e), { id: s, type: n, container: e });
                            this.instances.push(o);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++)
                        if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                _onSectionLoad: function (e, t, i) {
                    window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                    var s = t || e.target,
                        n = t || e.target.querySelector("[data-section-id]");
                    if (n) {
                        this._createInstance(n);
                        var o = t ? i : this._findInstance(e.detail.sectionId);
                        s.querySelectorAll("[data-subsection]").length && this.loadSubSections(s),
                            o && "function" == typeof o.onLoad && o.onLoad(e),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("scroll"));
                            }, 200);
                    }
                },
                _onSectionUnload: function (e) {
                    this.instances = this.instances.filter(function (t) {
                        var i = t.id === e.detail.sectionId;
                        return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
                    });
                },
                loadSubSections: function (e) {
                    e &&
                        e.querySelectorAll("[data-section-id]").forEach((e) => {
                            this._onSectionLoad(null, e, e.dataset.sectionId);
                        });
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                register: function (e, t, i) {
                    this.constructors[e] = t;
                    var s = document.querySelectorAll('[data-section-type="' + e + '"]');
                    i && (s = i.querySelectorAll('[data-section-type="' + e + '"]')),
                        s.forEach(
                            function (e) {
                                this._createInstance(e, t, i);
                            }.bind(this)
                        );
                },
                reinit: function (e) {
                    for (var t = 0; t < this.instances.length; t++) {
                        var i = this.instances[t];
                        i.type === e && "function" == typeof i.forceReload && i.forceReload();
                    }
                },
            })),
            (theme.Variants = (function () {
                function e(e) {
                    (this.container = e.container),
                        (this.variants = e.variants),
                        (this.singleOptionSelector = e.singleOptionSelector),
                        (this.originalSelectorId = e.originalSelectorId),
                        (this.enableHistoryState = e.enableHistoryState),
                        (this.dynamicVariantsEnabled = e.dynamicVariantsEnabled),
                        (this.currentlySelectedValues = this._getCurrentOptions()),
                        (this.currentVariant = this._getVariantFromOptions()),
                        this.container.querySelectorAll(this.singleOptionSelector).forEach((e) => {
                            e.addEventListener("change", this._onSelectChange.bind(this));
                        });
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        _getCurrentOptions: function () {
                            var e = [];
                            return (
                                this.container.querySelectorAll(this.singleOptionSelector).forEach((t) => {
                                    var i = t.getAttribute("type");
                                    "radio" === i || "checkbox" === i
                                        ? t.checked && e.push({ value: t.value, index: t.dataset.index })
                                        : e.push({ value: t.value, index: t.dataset.index });
                                }),
                                (e = theme.utils.compact(e))
                            );
                        },
                        _numberFromOptionKey: function (e) {
                            return parseInt(e.substr(-1));
                        },
                        _getWeightedOptionMatchCount: function (e) {
                            return this._getCurrentOptions().reduce((t, { value: i, index: s }) => {
                                const n = 4 - this._numberFromOptionKey(s);
                                return e[s] === i ? t + n : t;
                            }, 0);
                        },
                        _getFullMatch(e) {
                            const t = this._getCurrentOptions();
                            return this.variants.find((i) => {
                                const s = t.every(({ value: e, index: t }) => i[t] === e);
                                return e ? s && i.available : s;
                            });
                        },
                        _getClosestAvailableMatch: function (e) {
                            if (!e) return null;
                            const t = this._getCurrentOptions(),
                                i = this.variants;
                            return (
                                e &&
                                i.filter(
                                    (i) =>
                                        t
                                            .filter(
                                                ({ value: t, index: i }) =>
                                                    this._numberFromOptionKey(i) <= this._numberFromOptionKey(e.index)
                                            )
                                            .every(({ value: e, index: t }) => i[t] === e) && i.available
                                )
                            ).reduce((t, i) => {
                                if (null === t) return i;
                                const s = this._getWeightedOptionMatchCount(t, e);
                                return this._getWeightedOptionMatchCount(i, e) > s ? i : t;
                            }, null);
                        },
                        _getVariantFromOptions: function (e) {
                            const t = this._getFullMatch(!0),
                                i = this._getClosestAvailableMatch(e),
                                s = this._getFullMatch(!1);
                            return this.dynamicVariantsEnabled ? t || i || s || null : s || null;
                        },
                        _updateInputState: function (e, t) {
                            return (t) => {
                                if (null === e) return;
                                const i = t.dataset.index,
                                    s = t.value,
                                    n = t.getAttribute("type");
                                "radio" === n || "checkbox" === n
                                    ? ((t.checked = e[i] === s),
                                      t.checked && t.dispatchEvent(new Event("updateSwatch")))
                                    : (t.value = e[i]);
                            };
                        },
                        _onSelectChange: function ({ srcElement: e }) {
                            const t = this.container.querySelectorAll(this.singleOptionSelector),
                                i = this._getVariantFromOptions({ index: e.dataset.index, value: e.value });
                            t.forEach(this._updateInputState(i, e));
                            const s = {
                                variant: i,
                                currentlySelectedValues: (this.currentlySelectedValues = this._getCurrentOptions()),
                                value: e.value,
                                index: e.parentElement.dataset.index,
                            };
                            this.container.dispatchEvent(new CustomEvent("variantChange", { detail: s })),
                                document.dispatchEvent(new CustomEvent("variant:change", { detail: s })),
                                i &&
                                    (this._updateMasterSelect(i),
                                    this._updateImages(i),
                                    this._updatePrice(i),
                                    this._updateUnitPrice(i),
                                    this._updateSKU(i),
                                    (this.currentVariant = i),
                                    this.enableHistoryState && this._updateHistoryState(i));
                        },
                        _updateImages: function (e) {
                            e.featured_image &&
                                this.container.dispatchEvent(
                                    new CustomEvent("variantImageChange", { detail: { variant: e } })
                                );
                        },
                        _updatePrice: function (e) {
                            (this.currentVariant &&
                                e.price === this.currentVariant.price &&
                                e.compare_at_price === this.currentVariant.compare_at_price) ||
                                this.container.dispatchEvent(
                                    new CustomEvent("variantPriceChange", { detail: { variant: e } })
                                );
                        },
                        _updateUnitPrice: function (e) {
                            (this.currentVariant && e.unit_price === this.currentVariant.unit_price) ||
                                this.container.dispatchEvent(
                                    new CustomEvent("variantUnitPriceChange", { detail: { variant: e } })
                                );
                        },
                        _updateSKU: function (e) {
                            (this.currentVariant && e.sku === this.currentVariant.sku) ||
                                this.container.dispatchEvent(
                                    new CustomEvent("variantSKUChange", { detail: { variant: e } })
                                );
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t =
                                    window.location.protocol +
                                    "//" +
                                    window.location.host +
                                    window.location.pathname +
                                    "?variant=" +
                                    e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (e) {
                            let t = this.container.querySelector(this.originalSelectorId);
                            t && ((t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 })));
                        },
                    })),
                    e
                );
            })()),
            (window.vimeoApiReady = function () {
                (theme.config.vimeoLoading = !0),
                    (function () {
                        let e, t;
                        return new Promise((i, s) => {
                            (e = setInterval(function () {
                                Vimeo && (clearInterval(e), clearTimeout(t), i());
                            }, 500)),
                                (t = setTimeout(function () {
                                    clearInterval(e), s();
                                }, 4e3));
                        });
                    })().then(function () {
                        (theme.config.vimeoReady = !0),
                            (theme.config.vimeoLoading = !1),
                            document.dispatchEvent(new CustomEvent("vimeoReady"));
                    });
            }),
            (theme.VimeoPlayer = (function () {
                const e = "loading",
                    t = "loaded",
                    i = "video-interactable",
                    s = { byline: !1, loop: !0, muted: !0, playsinline: !0, portrait: !1, title: !1 };
                function n(e, t, i) {
                    (this.divId = e),
                        (this.el = document.getElementById(e)),
                        (this.videoId = t),
                        (this.iframe = null),
                        (this.options = i),
                        this.options &&
                            this.options.videoParent &&
                            (this.parent = this.el.closest(this.options.videoParent)),
                        this.setAsLoading(),
                        theme.config.vimeoReady
                            ? this.init()
                            : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                              document.addEventListener("vimeoReady", this.init.bind(this)));
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function () {
                            const e = s;
                            (e.id = this.videoId),
                                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                                this.videoPlayer.ready().then(this.playerReady.bind(this));
                        },
                        playerReady: function () {
                            (this.iframe = this.el.querySelector("iframe")),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "false" === this.options.loop && this.videoPlayer.setLoop(!1),
                                "sound" === this.options.style
                                    ? this.videoPlayer.setVolume(1)
                                    : this.videoPlayer.setVolume(0),
                                this.setAsLoaded();
                            new IntersectionObserver(
                                (e, t) => {
                                    e.forEach((e) => {
                                        e.isIntersecting ? this.play() : this.pause();
                                    });
                                },
                                { rootMargin: "0px 0px 50px 0px" }
                            ).observe(this.iframe);
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e);
                        },
                        setAsLoaded: function () {
                            this.parent &&
                                (this.parent.classList.remove(e),
                                this.parent.classList.add(t),
                                this.parent.classList.add(i),
                                Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add(i);
                        },
                        play: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play();
                        },
                        pause: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause();
                        },
                        destroy: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.destroy &&
                                this.videoPlayer.destroy();
                        },
                    })),
                    n
                );
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), document.dispatchEvent(new CustomEvent("youTubeReady"));
            }),
            (theme.YouTube = (function () {
                var e = "loading",
                    t = "loaded",
                    i = "video-interactable",
                    s = {
                        width: 1280,
                        height: 720,
                        playerVars: {
                            autohide: 0,
                            autoplay: 1,
                            cc_load_policy: 0,
                            controls: 0,
                            fs: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            rel: 0,
                        },
                    };
                function n(e, t) {
                    (this.divId = e),
                        (this.iframe = null),
                        (this.attemptedToPlay = !1),
                        (s.events = {
                            onReady: this.onVideoPlayerReady.bind(this),
                            onStateChange: this.onVideoStateChange.bind(this),
                        }),
                        (this.options = Object.assign({}, s, t)),
                        this.options &&
                            (this.options.videoParent &&
                                (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)),
                            this.options.autoplay || (this.options.playerVars.autoplay = this.options.autoplay),
                            "sound" === this.options.style &&
                                ((this.options.playerVars.controls = 1), (this.options.playerVars.autoplay = 0))),
                        this.setAsLoading(),
                        theme.config.youTubeReady
                            ? this.init()
                            : (theme.LibraryLoader.load("youtubeSdk"),
                              document.addEventListener("youTubeReady", this.init.bind(this)));
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function () {
                            this.videoPlayer = new YT.Player(this.divId, this.options);
                        },
                        onVideoPlayerReady: function (e) {
                            (this.iframe = document.getElementById(this.divId)),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "sound" !== this.options.style && e.target.mute(),
                                new IntersectionObserver(
                                    (e, t) => {
                                        e.forEach((e) => {
                                            e.isIntersecting ? this.play() : this.pause();
                                        });
                                    },
                                    { rootMargin: "0px 0px 50px 0px" }
                                ).observe(this.iframe);
                        },
                        onVideoStateChange: function (e) {
                            switch (e.data) {
                                case -1:
                                    this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                                    break;
                                case 0:
                                    this.play(e);
                                    break;
                                case 1:
                                    this.setAsLoaded();
                                    break;
                                case 3:
                                    this.attemptedToPlay = !0;
                            }
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e);
                        },
                        setAsLoaded: function () {
                            this.parent &&
                                (this.parent.classList.remove(e),
                                this.parent.classList.add(t),
                                Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add(i);
                        },
                        play: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.playVideo &&
                                this.videoPlayer.playVideo();
                        },
                        pause: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.pauseVideo &&
                                this.videoPlayer.pauseVideo();
                        },
                        destroy: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.destroy &&
                                this.videoPlayer.destroy();
                        },
                    })),
                    n
                );
            })()),
            (r = !1),
            document.body.addEventListener("touchstart", function (e) {
                if (!e.target.closest(".flickity-slider")) return (r = !1);
                (r = !0), (a = { x: e.touches[0].pageX, y: e.touches[0].pageY });
            }),
            document.body.addEventListener(
                "touchmove",
                function (e) {
                    if (r && e.cancelable) {
                        var t = { x: e.touches[0].pageX - a.x, y: e.touches[0].pageY - a.y };
                        Math.abs(t.x) > Flickity.defaults.dragThreshold && e.preventDefault();
                    }
                },
                { passive: !1 }
            ),
            (theme.AjaxRenderer = (function () {
                function e({ sections: e, onReplace: t, debug: i } = {}) {
                    (this.sections = e || []),
                        (this.cachedSections = []),
                        (this.onReplace = t),
                        (this.debug = Boolean(i));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        renderPage: function (e, t, i = !0) {
                            const s = new URLSearchParams(window.location.search),
                                n = this.getUpdatedParams(s, t),
                                o = this.sections.map((t) => {
                                    const i = `${e}?section_id=${t.sectionId}&${n.toString()}`,
                                        s = (e) => e.url === i;
                                    return this.cachedSections.some(s)
                                        ? this.renderSectionFromCache(s, t)
                                        : this.renderSectionFromFetch(i, t);
                                });
                            return i && this.updateURLHash(n), Promise.all(o);
                        },
                        renderSectionFromCache: function (e, t) {
                            const i = this.cachedSections.find(e);
                            return (
                                this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`),
                                this.renderSection(i.html, t),
                                Promise.resolve(t)
                            );
                        },
                        renderSectionFromFetch: function (e, t) {
                            return (
                                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                                new Promise((i, s) => {
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((s) => {
                                            const n = s;
                                            (this.cachedSections = [...this.cachedSections, { html: n, url: e }]),
                                                this.renderSection(n, t),
                                                i(t);
                                        })
                                        .catch((e) => s(e));
                                })
                            );
                        },
                        renderSection: function (e, t) {
                            this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`);
                            const i = new DOMParser().parseFromString(e, "text/html");
                            if (this.onReplace) this.onReplace(i, t);
                            else if ("string" == typeof t.nodeId) {
                                var s = i.getElementById(t.nodeId);
                                if (!s) return;
                                document.getElementById(t.nodeId).innerHTML = s.innerHTML;
                            } else
                                t.nodeId.forEach((e) => {
                                    document.getElementById(e).innerHTML = i.getElementById(e).innerHTML;
                                });
                            return t;
                        },
                        getUpdatedParams: function (e, t) {
                            const i = new URLSearchParams(e),
                                s = ["sort_by", "q", "options[prefix]", "type"];
                            for (const [e, n] of i.entries()) t.getAll(e).includes(n) || s.includes(e) || i.delete(e);
                            for (const [e, s] of t.entries()) i.getAll(e).includes(s) || "" === s || i.append(e, s);
                            return i;
                        },
                        updateURLHash: function (e) {
                            history.pushState({}, "", `${window.location.pathname}${e && "?".concat(e)}`);
                        },
                        log: function (...e) {
                            this.debug && console.log(...e);
                        },
                    })),
                    e
                );
            })()),
            window.Shopify &&
                window.Shopify.theme &&
                navigator &&
                navigator.sendBeacon &&
                window.Shopify.designMode &&
                navigator.sendBeacon(
                    "https://api.archetypethemes.co/api/beacon",
                    new URLSearchParams({
                        shop: window.Shopify.shop,
                        themeName:
                            window.theme &&
                            window.theme.settings &&
                            `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
                        role: window.Shopify.theme.role,
                        route: window.location.pathname,
                        themeId: window.Shopify.theme.id,
                        themeStoreId: window.Shopify.theme.theme_store_id || 0,
                        isThemeEditor: !!window.Shopify.designMode,
                    })
                ),
            (theme.cart = {
                getCart: function () {
                    var e = "".concat(theme.routes.cart, "?t=").concat(Date.now());
                    return fetch(e, { credentials: "same-origin", method: "GET" }).then((e) => e.json());
                },
                getCartProductMarkup: function () {
                    var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
                    return (
                        (e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"),
                        fetch(e, { credentials: "same-origin", method: "GET" })
                            .then((e) => e.text())
                            .catch((e) => console.error(e))
                    );
                },
                changeItem: function (e, t) {
                    return this._updateCart({
                        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                        data: JSON.stringify({ id: e, quantity: t }),
                    });
                },
                _updateCart: function (e) {
                    return fetch(e.url, {
                        method: "POST",
                        body: e.data,
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/json",
                        },
                    })
                        .then((e) => e.text())
                        .then((e) => e);
                },
                updateAttribute: function (e, t) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ attributes: { [e]: theme.cart.attributeToString(t) } }),
                    });
                },
                updateNote: function (e) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
                    });
                },
                attributeToString: function (e) {
                    return "string" != typeof e && "undefined" === (e += "") && (e = ""), e.trim();
                },
            }),
            (theme.CartForm = (function () {
                var e = "[data-products]",
                    t = ".js-qty__wrapper",
                    i = "[data-discounts]",
                    s = "[data-savings]",
                    n = "[data-subtotal]",
                    o = ".cart-link__bubble",
                    a = '[name="note"]',
                    r = ".cart__terms-checkbox",
                    c = ".cart__checkout",
                    d = "btn--loading",
                    l = { requiresTerms: !1 };
                function h(t) {
                    t &&
                        ((this.form = t),
                        (this.wrapper = t.parentNode),
                        (this.location = t.dataset.location),
                        (this.namespace = ".cart-" + this.location),
                        (this.products = t.querySelector(e)),
                        (this.submitBtn = t.querySelector(c)),
                        (this.discounts = t.querySelector(i)),
                        (this.savings = t.querySelector(s)),
                        (this.subtotal = t.querySelector(n)),
                        (this.termsCheckbox = t.querySelector(r)),
                        (this.noteInput = t.querySelector(a)),
                        (this.cartItemsUpdated = !1),
                        this.termsCheckbox && (l.requiresTerms = !0),
                        this.init());
                }
                return (
                    (h.prototype = Object.assign({}, h.prototype, {
                        init: function () {
                            this.initQtySelectors(),
                                document.addEventListener(
                                    "cart:quantity" + this.namespace,
                                    this.quantityChanged.bind(this)
                                ),
                                this.form.on("submit" + this.namespace, this.onSubmit.bind(this)),
                                this.noteInput &&
                                    this.noteInput.addEventListener("change", function () {
                                        var e = this.value;
                                        theme.cart.updateNote(e);
                                    }),
                                document.addEventListener(
                                    "cart:build",
                                    function () {
                                        this.buildCart();
                                    }.bind(this)
                                );
                        },
                        reInit: function () {
                            this.initQtySelectors();
                        },
                        onSubmit: function (e) {
                            return (
                                this.submitBtn.classList.add(d),
                                (document.documentElement.classList.contains("js-drawer-open") &&
                                    this.cartItemsUpdated) ||
                                (document.documentElement.classList.contains("cart-open") && this.cartItemsUpdated)
                                    ? (this.submitBtn.classList.remove(d), e.preventDefault(), !1)
                                    : l.requiresTerms && !this.termsCheckbox.checked
                                      ? (alert(theme.strings.cartTermsConfirmation),
                                        this.submitBtn.classList.remove(d),
                                        e.preventDefault(),
                                        !1)
                                      : void 0
                            );
                        },
                        _parseProductHTML: function (e) {
                            const t = document.createElement("div");
                            return (
                                (t.innerHTML = e),
                                {
                                    items: t.querySelector(".cart__items"),
                                    discounts: t.querySelector(".cart__discounts"),
                                }
                            );
                        },
                        buildCart: function () {
                            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
                        },
                        cartMarkup: function (e) {
                            var t = this._parseProductHTML(e),
                                i = t.items,
                                s = parseInt(i.dataset.count),
                                n = i.dataset.cartSubtotal,
                                o = i.dataset.cartSavings;
                            this.updateCartDiscounts(t.discounts),
                                this.updateSavings(o),
                                s > 0
                                    ? this.wrapper.classList.remove("is-empty")
                                    : this.wrapper.classList.add("is-empty"),
                                this.updateCount(s),
                                (this.products.innerHTML = ""),
                                this.products.append(i),
                                (this.subtotal.innerHTML = theme.Currency.formatMoney(n, theme.settings.moneyFormat)),
                                this.reInit(),
                                window.AOS && AOS.refreshHard(),
                                Shopify &&
                                    Shopify.StorefrontExpressButtons &&
                                    Shopify.StorefrontExpressButtons.initialize();
                        },
                        updateCartDiscounts: function (e) {
                            this.discounts && ((this.discounts.innerHTML = ""), this.discounts.append(e));
                        },
                        initQtySelectors: function () {
                            this.form.querySelectorAll(t).forEach((e) => {
                                new theme.QtySelector(e, { namespace: this.namespace, isCart: !0 });
                            });
                        },
                        quantityChanged: function (e) {
                            var t = e.detail[0],
                                i = e.detail[1],
                                s = e.detail[2];
                            t &&
                                i &&
                                (s && s.classList.add("is-loading"),
                                theme.cart
                                    .changeItem(t, i)
                                    .then(
                                        function (i) {
                                            const s = JSON.parse(i);
                                            if (422 === s.status) alert(s.message);
                                            else {
                                                const i = s.items.find((e) => e.key === t);
                                                !i ||
                                                    ("cart:quantity.cart-cart-drawer" !== e.type &&
                                                        "cart:quantity.cart-header" !== e.type) ||
                                                    (this.cartItemsUpdated = !0),
                                                    ((i && "cart:quantity.cart-cart-drawer" === e.type) ||
                                                        (i && "cart:quantity.cart-header" === e.type)) &&
                                                        (i.quantity, (this.cartItemsUpdated = !1)),
                                                    s.item_count > 0
                                                        ? this.wrapper.classList.remove("is-empty")
                                                        : this.wrapper.classList.add("is-empty");
                                            }
                                            this.buildCart(),
                                                document.dispatchEvent(
                                                    new CustomEvent("cart:updated", { detail: { cart: s } })
                                                );
                                        }.bind(this)
                                    )
                                    .catch(function (e) {}));
                        },
                        updateSubtotal: function (e) {
                            this.form.querySelector(n).innerHTML = theme.Currency.formatMoney(
                                e,
                                theme.settings.moneyFormat
                            );
                        },
                        updateSavings: function (e) {
                            if (this.savings)
                                if (e > 0) {
                                    var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                                    this.savings.classList.remove("hide"),
                                        (this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", t));
                                } else this.savings.classList.add("hide");
                        },
                        updateCount: function (e) {
                            var t = document.querySelectorAll(".cart-link__bubble-num");
                            t.length &&
                                t.forEach((t) => {
                                    t.innerText = e;
                                });
                            var i = document.querySelectorAll(o);
                            i.length &&
                                (e > 0
                                    ? i.forEach((e) => {
                                          e.classList.add("cart-link__bubble--visible");
                                      })
                                    : i.forEach((e) => {
                                          e.classList.remove("cart-link__bubble--visible");
                                      }));
                        },
                    })),
                    h
                );
            })()),
            (theme.collapsibles = (function () {
                var e = {
                        trigger: ".collapsible-trigger",
                        module: ".collapsible-content",
                        moduleInner: ".collapsible-content__inner",
                        tabs: ".collapsible-trigger--tab",
                    },
                    t = {
                        hide: "hide",
                        open: "is-open",
                        autoHeight: "collapsible--auto-height",
                        tabs: "collapsible-trigger--tab",
                    },
                    i = ".collapsible",
                    s = !1;
                function n(i) {
                    if (!s) {
                        s = !0;
                        var n = i.currentTarget,
                            a = n.classList.contains(t.open),
                            r = n.classList.contains(t.tabs),
                            c = n.getAttribute("aria-controls"),
                            d = document.getElementById(c);
                        if ((c || (c = n.dataset.controls), c)) {
                            if (!d)
                                document.querySelectorAll('[data-id="' + c + '"]').length > 0 &&
                                    (d = n.parentNode.querySelector('[data-id="' + c + '"]'));
                            if (d) {
                                var l = d.querySelector(e.moduleInner).offsetHeight,
                                    h = d.classList.contains(t.autoHeight),
                                    u = d.parentNode.closest(e.module),
                                    m = l;
                                if (r) {
                                    if (a) return void (s = !1);
                                    document
                                        .querySelectorAll(e.tabs + '[data-id="' + n.dataset.id + '"]')
                                        .forEach((e) => {
                                            e.classList.remove(t.open),
                                                o(document.querySelector("#" + e.getAttribute("aria-controls")), 0, !0);
                                        });
                                }
                                if (
                                    (a &&
                                        h &&
                                        setTimeout(function () {
                                            o(d, (l = 0), a, h);
                                        }, 0),
                                    a && !h && (l = 0),
                                    n.setAttribute("aria-expanded", !a),
                                    a ? n.classList.remove(t.open) : n.classList.add(t.open),
                                    o(d, l, a, h),
                                    u)
                                ) {
                                    var p = u.style.height;
                                    a && "auto" === p && (m = 0),
                                        o(u, a ? u.offsetHeight - m : l + u.offsetHeight, !1, !1);
                                }
                            } else s = !1;
                        }
                    }
                }
                function o(e, i, n, o) {
                    if (
                        (e.classList.remove(t.hide),
                        theme.utils.prepareTransition(e, function () {
                            (e.style.height = i + "px"), n ? e.classList.remove(t.open) : e.classList.add(t.open);
                        }),
                        !n && o)
                    ) {
                        var a = e;
                        window.setTimeout(function () {
                            a.css("height", "auto"), (s = !1);
                        }, 500);
                    } else s = !1;
                }
                return {
                    init: function (s) {
                        (s || document).querySelectorAll(e.trigger).forEach((e) => {
                            var s = e.classList.contains(t.open);
                            e.setAttribute("aria-expanded", s), e.off("click" + i), e.on("click" + i, n);
                        });
                    },
                };
            })()),
            (theme.Disclosure = (function () {
                var e = "[data-disclosure-form]",
                    t = "[data-disclosure-list]",
                    i = "[data-disclosure-toggle]",
                    s = "[data-disclosure-input]",
                    n = "[data-disclosure-option]",
                    o = "disclosure-list--visible";
                function a(e) {
                    (this.container = e), this._cacheSelectors(), this._setupListeners();
                }
                return (
                    (a.prototype = Object.assign({}, a.prototype, {
                        _cacheSelectors: function () {
                            this.cache = {
                                disclosureForm: this.container.closest(e),
                                disclosureList: this.container.querySelector(t),
                                disclosureToggle: this.container.querySelector(i),
                                disclosureInput: this.container.querySelector(s),
                                disclosureOptions: this.container.querySelectorAll(n),
                            };
                        },
                        _setupListeners: function () {
                            (this.eventHandlers = this._setupEventHandlers()),
                                this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.addEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.addEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureListFocusOut
                                ),
                                this.cache.disclosureToggle.addEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureToggleFocusOut
                                ),
                                document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                        },
                        _setupEventHandlers: function () {
                            return {
                                connectOptions: this._connectOptions.bind(this),
                                toggleList: this._toggleList.bind(this),
                                onBodyClick: this._onBodyClick.bind(this),
                                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                                onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                                onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                            };
                        },
                        _connectOptions: function (e) {
                            e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                        },
                        _onDisclosureToggleFocusOut: function (e) {
                            !1 === this.container.contains(e.relatedTarget) && this._hideList();
                        },
                        _onDisclosureListFocusOut: function (e) {
                            var t = e.currentTarget.contains(e.relatedTarget);
                            this.cache.disclosureList.classList.contains(o) && !t && this._hideList();
                        },
                        _onDisclosureKeyUp: function (e) {
                            27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                        },
                        _onBodyClick: function (e) {
                            var t = this.container.contains(e.target);
                            this.cache.disclosureList.classList.contains(o) && !t && this._hideList();
                        },
                        _submitForm: function (e) {
                            (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                        },
                        _hideList: function () {
                            this.cache.disclosureList.classList.remove(o),
                                this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                        },
                        _toggleList: function () {
                            var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                            this.cache.disclosureList.classList.toggle(o),
                                this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                        },
                        destroy: function () {
                            this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.removeEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.removeEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureListFocusOut
                                ),
                                this.cache.disclosureToggle.removeEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureToggleFocusOut
                                ),
                                document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                        },
                    })),
                    a
                );
            })()),
            (theme.Drawers = (function () {
                function e(e, t) {
                    (this.config = {
                        id: e,
                        close: ".js-drawer-close",
                        open: ".js-drawer-open-" + t,
                        openClass: "js-drawer-open",
                        closingClass: "js-drawer-closing",
                        activeDrawer: "drawer--is-open",
                        namespace: ".drawer-" + t,
                    }),
                        (this.nodes = { page: document.querySelector("#MainContent") }),
                        (this.drawer = document.querySelector("#" + e)),
                        (this.isOpen = !1),
                        this.drawer && this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            document.querySelectorAll(this.config.open).forEach((e) => {
                                e.setAttribute("aria-expanded", "false"),
                                    e.addEventListener("click", this.open.bind(this));
                            }),
                                this.drawer
                                    .querySelector(this.config.close)
                                    .addEventListener("click", this.close.bind(this)),
                                document.addEventListener(
                                    "modalOpen",
                                    function () {
                                        this.close();
                                    }.bind(this)
                                );
                        },
                        open: function (e, t) {
                            e && e.preventDefault(),
                                this.isOpen ||
                                    (e && e.stopPropagation
                                        ? (e.stopPropagation(),
                                          e.currentTarget.setAttribute("aria-expanded", "true"),
                                          (this.activeSource = e.currentTarget))
                                        : t && (t.setAttribute("aria-expanded", "true"), (this.activeSource = t)),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.add(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.add(this.config.openClass),
                                    (this.isOpen = !0),
                                    theme.a11y.trapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    document.dispatchEvent(new CustomEvent("drawerOpen")),
                                    document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)),
                                    this.bindEvents());
                        },
                        close: function (e) {
                            if (this.isOpen) {
                                if (e)
                                    if (e.target.closest(".js-drawer-close"));
                                    else if (e.target.closest(".drawer")) return;
                                document.activeElement.blur(),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.remove(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.remove(this.config.openClass),
                                    document.documentElement.classList.add(this.config.closingClass),
                                    window.setTimeout(
                                        function () {
                                            document.documentElement.classList.remove(this.config.closingClass),
                                                this.activeSource &&
                                                    this.activeSource.getAttribute("aria-expanded") &&
                                                    (this.activeSource.setAttribute("aria-expanded", "false"),
                                                    this.activeSource.focus());
                                        }.bind(this),
                                        500
                                    ),
                                    (this.isOpen = !1),
                                    theme.a11y.removeTrapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    this.unbindEvents();
                            }
                        },
                        bindEvents: function () {
                            window.on(
                                "click" + this.config.namespace,
                                function (e) {
                                    this.close(e);
                                }.bind(this)
                            ),
                                window.on(
                                    "keyup" + this.config.namespace,
                                    function (e) {
                                        27 === e.keyCode && this.close();
                                    }.bind(this)
                                ),
                                theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                        unbindEvents: function () {
                            window.off("click" + this.config.namespace),
                                window.off("keyup" + this.config.namespace),
                                theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                    })),
                    e
                );
            })()),
            (theme.Modals = (function () {
                function e(e, t, i) {
                    var s = {
                        close: ".js-modal-close",
                        open: ".js-modal-open-" + t,
                        openClass: "modal--is-active",
                        closingClass: "modal--is-closing",
                        bodyOpenClass: ["modal-open"],
                        bodyOpenSolidClass: "modal-open--solid",
                        bodyClosingClass: "modal-closing",
                        closeOffContentClick: !0,
                    };
                    if (((this.id = e), (this.modal = document.getElementById(e)), !this.modal)) return !1;
                    (this.modalContent = this.modal.querySelector(".modal__inner")),
                        (this.config = Object.assign(s, i)),
                        (this.modalIsOpen = !1),
                        (this.focusOnOpen = this.config.focusIdOnOpen
                            ? document.getElementById(this.config.focusIdOnOpen)
                            : this.modal),
                        (this.isSolid = this.config.solid),
                        this.init();
                }
                return (
                    (e.prototype.init = function () {
                        document.querySelectorAll(this.config.open).forEach((e) => {
                            e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                        }),
                            this.modal.querySelectorAll(this.config.close).forEach((e) => {
                                e.addEventListener("click", this.close.bind(this));
                            }),
                            document.addEventListener(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (e.prototype.open = function (e) {
                        var t = !1;
                        this.modalIsOpen ||
                            (e ? e.preventDefault() : (t = !0),
                            e &&
                                e.stopPropagation &&
                                (e.stopPropagation(),
                                (this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true"))),
                            this.modalIsOpen && !t && this.close(),
                            this.modal.classList.add(this.config.openClass),
                            document.documentElement.classList.add(...this.config.bodyOpenClass),
                            this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            setTimeout(() => {
                                theme.a11y.trapFocus({
                                    container: this.modal,
                                    elementToFocus: this.focusOnOpen,
                                    namespace: "modal_focus",
                                });
                            }, 100),
                            document.dispatchEvent(new CustomEvent("modalOpen")),
                            document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
                            this.bindEvents());
                    }),
                    (e.prototype.close = function (e) {
                        if (this.modalIsOpen) {
                            if (e)
                                if (e.target.closest(".js-modal-close"));
                                else if (e.target.closest(".modal__inner")) return;
                            document.activeElement.blur(),
                                this.modal.classList.remove(this.config.openClass),
                                this.modal.classList.add(this.config.closingClass),
                                document.documentElement.classList.remove(...this.config.bodyOpenClass),
                                document.documentElement.classList.add(this.config.bodyClosingClass),
                                window.setTimeout(
                                    function () {
                                        document.documentElement.classList.remove(this.config.bodyClosingClass),
                                            this.modal.classList.remove(this.config.closingClass),
                                            this.activeSource &&
                                                this.activeSource.getAttribute("aria-expanded") &&
                                                this.activeSource.setAttribute("aria-expanded", "false").focus();
                                    }.bind(this),
                                    500
                                ),
                                this.isSolid &&
                                    document.documentElement.classList.remove(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                theme.a11y.removeTrapFocus({ container: this.modal, namespace: "modal_focus" }),
                                document.dispatchEvent(new CustomEvent("modalClose." + this.id)),
                                this.unbindEvents();
                        }
                    }),
                    (e.prototype.bindEvents = function () {
                        window.on(
                            "keyup.modal",
                            function (e) {
                                27 === e.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this));
                    }),
                    (e.prototype.unbindEvents = function () {
                        document.documentElement.off(".modal"),
                            this.config.closeOffContentClick && this.modal.off(".modal");
                    }),
                    e
                );
            })());
        class d extends HTMLElement {
            constructor() {
                super(),
                    (this.parallaxImage = this.querySelector("[data-parallax-image]")),
                    (this.windowInnerHeight = window.innerHeight),
                    (this.isActive = !1),
                    (this.timeout = null),
                    (this.directionMap = { right: 0, top: 90, left: 180, bottom: 270 }),
                    (this.directionMultipliers = { 0: [1, 0], 90: [0, -1], 180: [-1, 0], 270: [0, 1] }),
                    this.init(),
                    window.addEventListener("scroll", () => this.scrollHandler());
            }
            getParallaxInfo() {
                const { width: e, height: t, top: i } = this.parallaxImage.getBoundingClientRect();
                let s,
                    n = this.parallaxImage,
                    { angle: o, movement: a } = n.dataset,
                    r = "top" === o ? Math.ceil(t * (parseFloat(a) / 100)) : Math.ceil(e * (parseFloat(a) / 100));
                (o = this.directionMap[o] ?? parseFloat(o)),
                    o != o && (o = 270),
                    r != r && (r = 100),
                    (o %= 360),
                    o < 0 && (o += 360);
                const c = o > 90 && o < 270,
                    d = o < 180;
                if (((n.style[c ? "left" : "right"] = 0), (n.style[d ? "top" : "bottom"] = 0), o % 90)) {
                    const e = (o * Math.PI) / 180;
                    s = [Math.cos(e), -1 * Math.sin(e)];
                } else s = this.directionMultipliers[o];
                return (
                    s[0] && (n.style.width = `calc(100% + ${r * Math.abs(s[0])}px)`),
                    s[1] && (n.style.height = `calc(100% + ${r * Math.abs(s[1])}px)`),
                    { element: n, movementPixels: r, multipliers: s, top: i, height: t }
                );
            }
            init() {
                const { element: e, movementPixels: t, multipliers: i, top: s, height: n } = this.getParallaxInfo(),
                    o = (this.windowInnerHeight - s) / (this.windowInnerHeight + n);
                if (o > -0.1 && o < 1.1) {
                    const s = Math.min(Math.max(o, 0), 1) * t;
                    e.style.transform = `translate3d(${s * i[0]}px, ${s * i[1]}px, 0)`;
                }
                this.isActive && requestAnimationFrame(this.init.bind(this));
            }
            scrollHandler() {
                this.isActive
                    ? clearTimeout(this.timeout)
                    : ((this.isActive = !0), requestAnimationFrame(this.init.bind(this))),
                    (this.timeout = setTimeout(() => (this.isActive = !1), 20));
            }
        }
        if ((customElements.define("parallax-image", d), void 0 === window.noUiSlider))
            throw new Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        (theme.PriceRange = (function () {
            var e = ".price-range__slider",
                t = ".price-range__input-min",
                i = ".price-range__input-max",
                s = ".price-range__display-min",
                n = ".price-range__display-max";
            function o(e, { onChange: t, onUpdate: i, ...s } = {}) {
                return (
                    (this.container = e),
                    (this.onChange = t),
                    (this.onUpdate = i),
                    (this.sliderOptions = s || {}),
                    this.init()
                );
            }
            return (
                (o.prototype = Object.assign({}, o.prototype, {
                    init: function () {
                        if (!this.container.classList.contains("price-range"))
                            throw new Error("You must instantiate PriceRange with a valid container");
                        return (
                            (this.formEl = this.container.closest("form")),
                            (this.sliderEl = this.container.querySelector(e)),
                            (this.inputMinEl = this.container.querySelector(t)),
                            (this.inputMaxEl = this.container.querySelector(i)),
                            (this.displayMinEl = this.container.querySelector(s)),
                            (this.displayMaxEl = this.container.querySelector(n)),
                            (this.minRange = parseFloat(this.container.dataset.min) || 0),
                            (this.minValue = parseFloat(this.container.dataset.minValue) || 0),
                            (this.maxRange = parseFloat(this.container.dataset.max) || 100),
                            (this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange),
                            this.createPriceRange()
                        );
                    },
                    createPriceRange: function () {
                        this.sliderEl &&
                            this.sliderEl.noUiSlider &&
                            "function" == typeof this.sliderEl.noUiSlider.destroy &&
                            this.sliderEl.noUiSlider.destroy();
                        var e = noUiSlider.create(this.sliderEl, {
                            connect: !0,
                            step: 10,
                            ...this.sliderOptions,
                            start: [this.minValue, this.maxValue],
                            range: { min: this.minRange, max: this.maxRange },
                        });
                        return (
                            e.on("update", (e) => {
                                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                                    e[0],
                                    theme.settings.moneyFormat
                                )),
                                    (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                                        e[1],
                                        theme.settings.moneyFormat
                                    )),
                                    this.onUpdate && this.onUpdate(e);
                            }),
                            e.on("change", (e) => {
                                if (((this.inputMinEl.value = e[0]), (this.inputMaxEl.value = e[1]), this.onChange)) {
                                    const e = new FormData(this.formEl);
                                    this.onChange(e);
                                }
                            }),
                            e
                        );
                    },
                })),
                o
            );
        })()),
            (theme.AjaxProduct = (function () {
                var e = { loading: !1 };
                function t(e, t, i) {
                    (this.form = e), (this.args = i);
                    var s = t || ".add-to-cart";
                    this.form &&
                        ((this.addToCart = e.querySelector(s)),
                        this.form.addEventListener("submit", this.addItemFromForm.bind(this)));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        addItemFromForm: function (t, i) {
                            if ((t.preventDefault(), !e.loading)) {
                                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                                var s = theme.utils.serialize(this.form);
                                console.log("Serialized form:", s);
                               var selectedBundles = document.querySelectorAll('.bundle-item.active');

                                    if (selectedBundles.length > 0) {
                                    // append selected bundles to the request
                                    selectedBundles.forEach(function(bundleItem, index){
                                        var bundleId = bundleItem.getAttribute('data-id');
                                        s += '&items[' + index + '][id]=' + bundleId + '&items[' + index + '][quantity]=1';
                                    });
                                    }
                                    selectedBundles.forEach(function (bundleItem) {
                                        bundleItem.classList.remove('active');
                                    });
                                fetch(theme.routes.cartAdd, {
                                    method: "POST",
                                    body: s,
                                    credentials: "same-origin",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded",
                                        "X-Requested-With": "XMLHttpRequest",
                                    },
                                })
                                    .then((e) => e.json())
                                    .then(
                                        function (t) {
                                            if (422 === t.status) this.error(t);
                                            else {
                                                var i = t;
                                                this.success(i);
                                            }
                                            (e.loading = !1),
                                                this.addToCart.classList.remove("btn--loading"),
                                                document.body.classList.contains("template-cart") &&
                                                    (window.scrollTo(0, 0), location.reload());
                                        }.bind(this)
                                    );
                            }
                        },
                        success: function (e) {
                            var t = this.form.querySelector(".errors");
                            t && t.remove(),
                                "page" === theme.settings.cartType && (window.location = theme.routes.cartPage),
                                this.form.dispatchEvent(
                                    new CustomEvent("ajaxProduct:added", {
                                        detail: { product: e, addToCartBtn: this.addToCart },
                                        bubbles: !0,
                                    })
                                ),
                                this.args &&
                                    this.args.scopedEventId &&
                                    document.dispatchEvent(
                                        new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
                                            detail: { product: e, addToCartBtn: this.addToCart },
                                        })
                                    );
                        },
                            error: function (e) {
                                if (e.description) {

                                var productBlock = this.form.closest(".product-block");
                                var t = productBlock ? productBlock.parentNode.querySelector(".errors") : null;

                                if (t) t.remove();

                                var i = document.createElement("div");
                                i.classList.add("errors", "text-center");

                                if (typeof e.description === "object") {
                                    i.textContent = e.message;
                                } else {
                                    i.textContent = e.description;
                                }

                                if (productBlock) {
                                    productBlock.after(i);
                                } else {
                                    this.form.after(i);
                                }

                                this.form.dispatchEvent(
                                    new CustomEvent("ajaxProduct:error", {
                                    detail: { errorMessage: e.description },
                                    bubbles: true,
                                    })
                                );

                                if (this.args && this.args.scopedEventId) {
                                    document.dispatchEvent(
                                    new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
                                        detail: { errorMessage: e.description },
                                    })
                                    );
                                }

                                } else {
                                console.warn(e);
                                }
                            }
                    })),
                    t
                );
            })()),
            (theme.ProductMedia = (function () {
                var e = {},
                    t = {},
                    i = {},
                    s = "[data-product-single-media-group]",
                    n = "[data-shopify-xr]";
                function o(t) {
                    if (!t)
                        if (window.ShopifyXR) {
                            for (var i in e)
                                if (e.hasOwnProperty(i)) {
                                    var s = e[i];
                                    if (s.loaded) continue;
                                    var n = document.querySelector("#ModelJson-" + i);
                                    window.ShopifyXR.addModels(JSON.parse(n.innerHTML)), (s.loaded = !0);
                                }
                            window.ShopifyXR.setupXRElements();
                        } else
                            document.addEventListener("shopify_xr_initialized", function () {
                                o();
                            });
                }
                function a(e) {
                    if (!e)
                        for (var i in t)
                            if (t.hasOwnProperty(i)) {
                                var s = t[i];
                                !s.modelViewerUi && Shopify && (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)),
                                    r(s);
                            }
                }
                function r(e) {
                    var t = i[e.sectionId];
                    e.container.addEventListener("mediaVisible", function (i) {
                        t.element.setAttribute("data-shopify-model3d-id", e.modelId),
                            theme.config.isTouch || (i.detail.autoplayMedia && e.modelViewerUi.play());
                    }),
                        e.container.addEventListener("mediaHidden", function () {
                            t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                        }),
                        e.container.addEventListener("xrLaunch", function () {
                            e.modelViewerUi.pause();
                        });
                }
                return {
                    init: function (r, c) {
                        (e[c] = { loaded: !1 }),
                            r.forEach(function (e, o) {
                                var a = e.dataset.mediaId,
                                    r = e.querySelector("model-viewer"),
                                    d = r.dataset.modelId;
                                if (0 === o) {
                                    var l = e.closest(s).querySelector(n);
                                    i[c] = { element: l, defaultId: d };
                                }
                                t[a] = { modelId: d, sectionId: c, container: e, element: r };
                            }),
                            window.Shopify.loadFeatures([
                                { name: "shopify-xr", version: "1.0", onLoad: o },
                                { name: "model-viewer-ui", version: "1.0", onLoad: a },
                            ]),
                            theme.LibraryLoader.load("modelViewerUiStyles");
                    },
                    removeSectionModels: function (i) {
                        for (var s in t) {
                            if (t.hasOwnProperty(s)) t[s].sectionId === i && delete t[s];
                        }
                        delete e[i];
                    },
                };
            })()),
            (theme.QtySelector = (function () {
                var e = ".js-qty__num",
                    t = ".js-qty__adjust--plus",
                    i = ".js-qty__adjust--minus";
                function s(s, n) {
                    (this.wrapper = s),
                        (this.plus = s.querySelector(t)),
                        (this.minus = s.querySelector(i)),
                        (this.input = s.querySelector(e)),
                        (this.minValue = this.input.getAttribute("min") || 1);
                    var o = { namespace: null, isCart: !1, key: this.input.dataset.id };
                    (this.options = Object.assign({}, o, n)), this.init();
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        init: function () {
                            this.plus.addEventListener(
                                "click",
                                function () {
                                    var e = this._getQty();
                                    this._change(e + 1);
                                }.bind(this)
                            ),
                                this.minus.addEventListener(
                                    "click",
                                    function () {
                                        var e = this._getQty();
                                        this._change(e - 1);
                                    }.bind(this)
                                ),
                                this.input.addEventListener(
                                    "change",
                                    function (e) {
                                        this._change(this._getQty());
                                    }.bind(this)
                                );
                        },
                        _getQty: function () {
                            var e = this.input.value;
                            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
                        },
                        _change: function (e) {
                            e <= this.minValue && (e = this.minValue),
                                (this.input.value = e),
                                this.options.isCart &&
                                    document.dispatchEvent(
                                        new CustomEvent("cart:quantity" + this.options.namespace, {
                                            detail: [this.options.key, e, this.wrapper],
                                        })
                                    );
                        },
                    })),
                    s
                );
            })()),
            (theme.initQuickShop = function () {
                var e = document.querySelectorAll(".grid-product");
                function t(e) {
                    var i = e.currentTarget;
                    if (!theme.config.bpSmall) {
                        if (
                            (i.removeEventListener("mouseover", t),
                            i.removeEventListener("focusin", t),
                            !i || !i.dataset.productId)
                        )
                            return;
                        var s = i.dataset.productId,
                            n = i.dataset.productHandle,
                            o = i.querySelector(".quick-product__btn");
                        theme.preloadProductModal(n, s, o);
                    }
                }
                e.length &&
                    theme.settings.quickView &&
                    e.forEach((e) => {
                        e.addEventListener("mouseover", t), e.addEventListener("focusin", t);
                    });
            }),
            (theme.preloadProductModal = function (e, t, i) {
                var s = document.getElementById("QuickShopHolder-" + e),
                    n = theme.routes.home + "/products/" + e + "?view=modal";
                (n = n.replace("//", "/")),
                    fetch(n)
                        .then((e) => e.text())
                        .then((n) => {
                            const o = document.createElement("div");
                            o.innerHTML = n;
                            const a = o.querySelector('.product-section[data-product-handle="' + e + '"]');
                            if (s) {
                                (s.innerHTML = ""), s.append(a);
                                var r = "QuickShopModal-" + t,
                                    c = "quick-modal-" + t;
                                new theme.Modals(r, c),
                                    theme.sections.register("product", theme.Product, s),
                                    theme.collapsibles.init(),
                                    theme.videoModal(),
                                    i && i.classList.remove("quick-product__btn--not-ready");
                            }
                        });
            }),
            (theme.Slideshow = (function () {
                var e = "animate-out",
                    t = "is-paused",
                    i = "is-active",
                    s = ".slideshow__slide",
                    n = ".is-selected",
                    o = ".slideshow-wrapper",
                    a = ".slideshow__pause",
                    r = ".product__thumb-item:not(.hide)",
                    c = ".product__thumb-item:not(.hide) a",
                    d = ".product__thumb-arrow",
                    l = {
                        adaptiveHeight: !1,
                        autoPlay: !1,
                        avoidReflow: !1,
                        childNav: null,
                        childNavScroller: null,
                        childVertical: !1,
                        dragThreshold: 7,
                        fade: !1,
                        friction: 0.8,
                        initialIndex: 0,
                        pageDots: !1,
                        pauseAutoPlayOnHover: !1,
                        prevNextButtons: !1,
                        rightToLeft: theme.config.rtl,
                        selectedAttraction: 0.14,
                        setGallerySize: !0,
                        wrapAround: !0,
                    };
                function h(e, t) {
                    if (
                        ((this.el = e),
                        (this.args = Object.assign({}, l, t)),
                        (this.args.on = {
                            ready: this.init.bind(this),
                            change: this.slideChange.bind(this),
                            settle: this.afterChange.bind(this),
                        }),
                        this.args.childNav &&
                            ((this.childNavEls = this.args.childNav.querySelectorAll(r)),
                            (this.childNavLinks = this.args.childNav.querySelectorAll(c)),
                            (this.arrows = this.args.childNav.querySelectorAll(d)),
                            this.childNavLinks.length && this.initChildNav()),
                        this.args.avoidReflow &&
                            (function (e) {
                                if (!e.id) return;
                                var t = e.firstChild;
                                for (; null != t && 3 == t.nodeType; ) t = t.nextSibling;
                                var i = document.createElement("style");
                                (i.innerHTML = `#${e.id} .flickity-viewport{height:${t.offsetHeight}px}`),
                                    document.head.appendChild(i);
                            })(e),
                        (this.slideshow = new Flickity(e, this.args)),
                        e.dataset.zoom &&
                            "true" === e.dataset.zoom &&
                            (this.slideshow.on("dragStart", () => {
                                (this.slideshow.slider.style.pointerEvents = "none"),
                                    this.slideshow.options.fade &&
                                        (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents =
                                            "none");
                            }),
                            this.slideshow.on("dragEnd", () => {
                                (this.slideshow.slider.style.pointerEvents = "auto"),
                                    this.slideshow.options.fade &&
                                        (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents =
                                            "auto");
                            })),
                        this.args.autoPlay)
                    ) {
                        var i = e.closest(o);
                        (this.pauseBtn = i.querySelector(a)),
                            this.pauseBtn && this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
                    }
                    window.on(
                        "resize",
                        theme.utils.debounce(
                            300,
                            function () {
                                this.resize();
                            }.bind(this)
                        )
                    );
                }
                return (
                    (h.prototype = Object.assign({}, h.prototype, {
                        init: function (e) {
                            (this.currentSlide = this.el.querySelector(n)),
                                this.args.callbacks &&
                                    this.args.callbacks.onInit &&
                                    "function" == typeof this.args.callbacks.onInit &&
                                    this.args.callbacks.onInit(this.currentSlide),
                                window.AOS && AOS.refresh();
                        },
                        slideChange: function (t) {
                            this.args.fade &&
                                this.currentSlide &&
                                (this.currentSlide.classList.add(e),
                                this.currentSlide.addEventListener(
                                    "transitionend",
                                    function () {
                                        this.currentSlide.classList.remove(e);
                                    }.bind(this)
                                )),
                                this.args.childNav && this.childNavGoTo(t),
                                this.args.callbacks &&
                                    this.args.callbacks.onChange &&
                                    "function" == typeof this.args.callbacks.onChange &&
                                    this.args.callbacks.onChange(t),
                                this.arrows &&
                                    this.arrows.length &&
                                    (this.arrows[0].classList.toggle("hide", 0 === t),
                                    this.arrows[1].classList.toggle("hide", t === this.childNavLinks.length - 1));
                        },
                        afterChange: function (t) {
                            this.args.fade &&
                                this.el.querySelectorAll(s).forEach((t) => {
                                    t.classList.remove(e);
                                }),
                                (this.currentSlide = this.el.querySelector(n)),
                                this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex);
                        },
                        destroy: function () {
                            this.args.childNav &&
                                this.childNavLinks.length &&
                                this.childNavLinks.forEach((e) => {
                                    e.classList.remove(i);
                                }),
                                this.slideshow.destroy();
                        },
                        reposition: function () {
                            this.slideshow.reposition();
                        },
                        _togglePause: function () {
                            this.pauseBtn.classList.contains(t)
                                ? (this.pauseBtn.classList.remove(t), this.slideshow.playPlayer())
                                : (this.pauseBtn.classList.add(t), this.slideshow.pausePlayer());
                        },
                        resize: function () {
                            this.slideshow.resize();
                        },
                        play: function () {
                            this.slideshow.playPlayer();
                        },
                        pause: function () {
                            this.slideshow.pausePlayer();
                        },
                        goToSlide: function (e) {
                            this.slideshow.select(e);
                        },
                        setDraggable: function (e) {
                            (this.slideshow.options.draggable = e), this.slideshow.updateDraggable();
                        },
                        initChildNav: function () {
                            this.childNavLinks[this.args.initialIndex].classList.add("is-active"),
                                this.childNavLinks.forEach((e, t) => {
                                    e.setAttribute("data-index", t),
                                        e.addEventListener(
                                            "click",
                                            function (e) {
                                                e.preventDefault(), this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "focus",
                                            function (e) {
                                                this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "keydown",
                                            function (e) {
                                                13 === e.keyCode && this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        );
                                }),
                                this.arrows.length &&
                                    this.arrows.forEach((e) => {
                                        e.addEventListener("click", this.arrowClick.bind(this));
                                    });
                        },
                        getChildIndex: function (e) {
                            return parseInt(e.dataset.index);
                        },
                        childNavGoTo: function (e) {
                            this.childNavLinks.forEach((e) => {
                                e.blur(), e.classList.remove(i);
                            });
                            var t = this.childNavLinks[e];
                            if ((t.classList.add(i), this.args.childNavScroller))
                                if (this.args.childVertical) {
                                    var s = t.offsetTop;
                                    this.args.childNavScroller.scrollTop = s - 100;
                                } else {
                                    var n = t.offsetLeft;
                                    this.args.childNavScroller.scrollLeft = n - 100;
                                }
                        },
                        arrowClick: function (e) {
                            e.currentTarget.classList.contains("product__thumb-arrow--prev")
                                ? this.slideshow.previous()
                                : this.slideshow.next();
                        },
                    })),
                    h
                );
            })()),
            (theme.VariantAvailability = (function () {
                var e = "disabled";
                function t(e) {
                    (this.type = e.type),
                        (this.variantsObject = e.variantsObject),
                        (this.currentVariantObject = e.currentVariantObject),
                        (this.container = e.container),
                        (this.namespace = e.namespace),
                        this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)),
                                this.setInitialAvailability();
                        },
                        createAvailableOptionsTree: (e, t) =>
                            e.reduce(
                                (e, i) => (
                                    Object.keys(e).forEach((s) => {
                                        if (null === i[s]) return;
                                        let n = e[s].find((e) => e.value === i[s]);
                                        void 0 === n && ((n = { value: i[s], soldOut: !0 }), e[s].push(n));
                                        const o = t.find(({ value: e, index: t }) => "option1" === t),
                                            a = t.find(({ value: e, index: t }) => "option2" === t);
                                        switch (s) {
                                            case "option1":
                                                n.soldOut = (!n.soldOut || !i.available) && n.soldOut;
                                                break;
                                            case "option2":
                                                o &&
                                                    i.option1 === o.value &&
                                                    (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                                            case "option3":
                                                o &&
                                                    i.option1 === o.value &&
                                                    a &&
                                                    i.option2 === a.value &&
                                                    (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                                        }
                                    }),
                                    e
                                ),
                                { option1: [], option2: [], option3: [] }
                            ),
                        setInitialAvailability: function () {
                            this.container.querySelectorAll(".variant-input-wrap").forEach((e) => {
                                this.disableVariantGroup(e);
                            });
                            const e = this.currentVariantObject.options.map((e, t) => ({
                                    value: e,
                                    index: `option${t + 1}`,
                                })),
                                t = this.createAvailableOptionsTree(this.variantsObject, e, this.currentVariantObject);
                            for (var [i, s] of Object.entries(t)) this.manageOptionState(i, s);
                        },
                        setAvailability: function (e) {
                            const { value: t, index: i, currentlySelectedValues: s, variant: n } = e.detail,
                                o = this.createAvailableOptionsTree(this.variantsObject, s, n, i, t);
                            for (var [a, r] of Object.entries(o)) this.manageOptionState(a, r, t);
                        },
                        manageOptionState: function (e, t) {
                            var i = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
                            t.forEach((e) => {
                                this.enableVariantOption(i, e);
                            });
                        },
                        enableVariantOption: function (t, i) {
                            var s = i.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                            if ("dropdown" === this.type)
                                i.soldOut
                                    ? (t.querySelector('option[value="' + s + '"]').disabled = !0)
                                    : (t.querySelector('option[value="' + s + '"]').disabled = !1);
                            else {
                                var n = t.querySelector('.variant-input[data-value="' + s + '"]'),
                                    o = n.querySelector("input"),
                                    a = n.querySelector("label");
                                o.classList.remove(e),
                                    a.classList.remove(e),
                                    i.soldOut && (o.classList.add(e), a.classList.add(e));
                            }
                        },
                        disableVariantGroup: function (t) {
                            "dropdown" === this.type
                                ? t.querySelectorAll("option").forEach((e) => {
                                      e.disabled = !0;
                                  })
                                : (t.querySelectorAll("input").forEach((t) => {
                                      t.classList.add(e);
                                  }),
                                  t.querySelectorAll("label").forEach((t) => {
                                      t.classList.add(e);
                                  }));
                        },
                    })),
                    t
                );
            })()),
            (theme.videoModal = function () {
                var e,
                    t,
                    i = "VideoHolder",
                    s = 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
                    n = 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
                    o = ".product-video-trigger--mp4",
                    a = ".product-video-mp4-sound",
                    r = document.querySelectorAll(s),
                    c = document.querySelectorAll(n),
                    d = document.querySelectorAll(o);
                if (r.length || c.length || d.length) {
                    var l = document.getElementById(i);
                    r.length && theme.LibraryLoader.load("youtubeSdk"),
                        c.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
                    var h = new theme.Modals("VideoModal", "video-modal", {
                        closeOffContentClick: !0,
                        bodyOpenClass: ["modal-open", "video-modal-open"],
                        solid: !0,
                    });
                    r.forEach((e) => {
                        e.addEventListener("click", u);
                    }),
                        c.forEach((e) => {
                            e.addEventListener("click", m);
                        }),
                        d.forEach((e) => {
                            e.addEventListener("click", p);
                        }),
                        document.addEventListener("modalClose.VideoModal", function () {
                            e && "function" == typeof e.destroy
                                ? e.destroy()
                                : t && "function" == typeof t.destroy
                                  ? t.destroy()
                                  : g();
                        });
                }
                function u(t) {
                    if (theme.config.youTubeReady) {
                        t.preventDefault(), g(), h.open(t);
                        var s,
                            n,
                            o,
                            a =
                                ((s = t.currentTarget.getAttribute("href")),
                                (n = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/),
                                !(!(o = s.match(n)) || 11 != o[7].length) && o[7]);
                        e = new theme.YouTube(i, { videoId: a, style: "sound", events: { onReady: f } });
                    }
                }
                function m(e) {
                    if (theme.config.vimeoReady) {
                        e.preventDefault(), g(), h.open(e);
                        var s = e.currentTarget.dataset.videoId,
                            n = e.currentTarget.dataset.videoLoop;
                        t = new theme.VimeoPlayer(i, s, { style: "sound", loop: n });
                    }
                }
                function p(e) {
                    g();
                    var t = e.currentTarget.parentNode.querySelector(a).cloneNode(!0);
                    t.classList.remove("hide"), l.append(t), h.open(e), l.querySelector("video").play();
                }
                function f(e) {
                    e.target.unMute(), e.target.playVideo();
                }
                function g() {
                    l.innerHTML = "";
                }
            });
        class l extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.inner = this.querySelector("[data-tool-tip-inner]")),
                    (this.closeButton = this.querySelector("[data-tool-tip-close]")),
                    (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
                    (this.toolTipTitle = this.querySelector("[data-tool-tip-title]")),
                    (this.triggers = document.querySelectorAll("[data-tool-tip-trigger]")),
                    document.addEventListener("tooltip:open", (e) => {
                        this._open(e.detail.context, e.detail.content);
                    });
            }
            _open(e, t) {
                (this.toolTipContent.innerHTML = t),
                    "store-availability" != e && this.toolTipTitle.remove(),
                    this._lockScrolling(),
                    this.closeButton &&
                        this.closeButton.on("click.tooltip-close", () => {
                            this._close();
                        }),
                    document.documentElement.on("click.tooltip-outerclick", (e) => {
                        "true" !== this.el.dataset.toolTipOpen || this.inner.contains(e.target) || this._close();
                    }),
                    document.documentElement.on("keydown.tooltip-esc", (e) => {
                        "Escape" === e.code && this._close();
                    }),
                    (this.el.dataset.toolTipOpen = !0),
                    (this.el.dataset.toolTip = e);
            }
            _close() {
                (this.toolTipContent.innerHTML = ""),
                    (this.el.dataset.toolTipOpen = "false"),
                    (this.el.dataset.toolTip = ""),
                    this._unlockScrolling(),
                    this.closeButton.off("click.tooltip-close"),
                    document.documentElement.off("click.tooltip-outerclick"),
                    document.documentElement.off("keydown.tooltip-esc");
            }
            _lockScrolling() {
                theme.a11y.trapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.lockMobileScrolling(),
                    document.documentElement.classList.add("modal-open");
            }
            _unlockScrolling() {
                theme.a11y.removeTrapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.unlockMobileScrolling(),
                    document.documentElement.classList.remove("modal-open");
            }
        }
        customElements.define("tool-tip", l);
        class h extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
                    this.init();
            }
            init() {
                const e = new CustomEvent("tooltip:open", {
                    detail: { context: this.dataset.toolTip, content: this.toolTipContent.innerHTML },
                    bubbles: !0,
                });
                this.el.addEventListener("click", (t) => {
                    t.stopPropagation(), this.dispatchEvent(e);
                });
            }
        }
        customElements.define("tool-tip-trigger", h);
        class u extends HTMLElement {
            constructor() {
                super(),
                    (this.closeBtn = this.querySelector("[data-close-button]")),
                    (this.popupTrigger = this.querySelector("[data-message]")),
                    (this.id = this.dataset.sectionId),
                    (this.newsletterId = `NewsletterPopup-${this.id}`),
                    (this.cookie = Cookies.get(`newsletter-${this.id}`)),
                    (this.cookieName = `newsletter-${this.id}`),
                    (this.secondsBeforeShow = this.dataset.delaySeconds),
                    (this.expiry = parseInt(this.dataset.delayDays)),
                    (this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, "newsletter-popup-modal")),
                    this.init();
            }
            init() {
                document.addEventListener("shopify:block:select", (e) => {
                    e.detail.sectionId === this.id && this.show(0, !0);
                }),
                    document.addEventListener("shopify:block:deselect", (e) => {
                        e.detail.sectionId === this.id && this.hide();
                    }),
                    document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide()),
                    document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show()),
                    document.addEventListener("newsletter:openReminder", () => this.show(0)),
                    this.closeBtn.addEventListener("click", () => {
                        this.hide(), Cookies.set(this.cookieName, "opened", { path: "/", expires: this.expiry });
                    }),
                    this.popupTrigger.addEventListener("click", () => {
                        const e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
                        this.dispatchEvent(e), this.hide();
                    });
            }
            show(e = this.secondsBeforeShow, t = !1) {
                "true" === sessionStorage.getItem("reminderAppeared") ||
                    setTimeout(() => {
                        (this.dataset.enabled = "true"), sessionStorage.setItem("reminderAppeared", !0);
                    }, 1e3 * e);
            }
            hide() {
                this.dataset.enabled = "false";
            }
        }
        customElements.define("newsletter-reminder", u);
        class m extends HTMLElement {
            constructor() {
                super(), this.init();
            }
            init() {
                new IntersectionObserver(
                    ((e, t) => {
                        e[0].isIntersecting && (this.removeAnimations(), t.unobserve(this));
                    }).bind(this),
                    { rootMargin: "0px 0px 400px 0px" }
                ).observe(this);
            }
            removeAnimations() {
                const e = this.closest(".image-wrap"),
                    t = this.closest(".skrim__link");
                e && e.classList.add("loaded"), t && t.classList.add("loaded");
            }
        }
        customElements.define("image-element", m);
        class p extends HTMLElement {
            constructor() {
                if (
                    (super(),
                    (this.enabled = this.getAttribute("data-enabled")),
                    (this.context = this.getAttribute("data-context")),
                    (this.input = this.querySelector('input[type="search"]')),
                    (this.predictiveSearchResults = this.querySelector("#predictive-search")),
                    (this.closeBtn = this.querySelector(".btn--close-search")),
                    (this.screen = this.querySelector("[data-screen]")),
                    (this.SearchModal = this.closest("#SearchModal") || null),
                    document.addEventListener("predictive-search:open", (e) => {
                        e.detail.context === this.context &&
                            (this.classList.add("is-active"),
                            setTimeout(() => {
                                this.input.focus();
                            }, 100),
                            document.body.classList.add("predictive-overflow-hidden"));
                    }),
                    this.SearchModal)
                ) {
                    new MutationObserver((e) => {
                        e.forEach((e) => {
                            if ("class" === e.attributeName) {
                                e.target.className.indexOf("modal--is-active") > -1 &&
                                    setTimeout(() => {
                                        this.input.focus();
                                    }, 100);
                            }
                        });
                    }).observe(this.SearchModal, { attributes: !0 });
                }
                "false" !== this.enabled &&
                    (this.input.addEventListener("keydown", () => {
                        this.classList.add("is-active");
                    }),
                    this.input.addEventListener(
                        "input",
                        this.debounce((e) => {
                            this.onChange(e);
                        }, 300).bind(this)
                    ),
                    document.addEventListener("predictive-search:close", () => {
                        this.close();
                    }),
                    document.addEventListener("keydown", (e) => {
                        27 === e.keyCode && this.close();
                    }),
                    this.closeBtn.addEventListener("click", (e) => {
                        e.preventDefault(), this.close();
                    }),
                    this.screen.addEventListener("click", () => {
                        this.close();
                    }));
            }
            onChange() {
                const e = this.input.value.trim();
                e.length && this.getSearchResults(e);
            }
            getSearchResults(e) {
                const t = {
                        q: e,
                        "resources[limit]": 3,
                        "resources[limit_scope]": "each",
                        "resources[options][unavailable_products]": "last",
                    },
                    i = this.paramUrl(t);
                fetch(`${theme.routes.predictiveSearch}?${i}&section_id=search-results`)
                    .then((e) => {
                        if (!e.ok) {
                            const t = new Error(e.status);
                            throw (this.close(), t);
                        }
                        return e.text();
                    })
                    .then((e) => {
                        const t = new DOMParser()
                            .parseFromString(e, "text/html")
                            .querySelector("#shopify-section-search-results").innerHTML;
                        (this.predictiveSearchResults.innerHTML = t), this.open(), AOS.refreshHard();
                    })
                    .catch((e) => {
                        throw (this.close(), e);
                    });
            }
            open() {
                this.predictiveSearchResults.style.display = "block";
            }
            close() {
                (this.predictiveSearchResults.style.display = "none"),
                    (this.predictiveSearchResults.innerHTML = ""),
                    this.classList.remove("is-active"),
                    document.body.classList.remove("predictive-overflow-hidden"),
                    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
            }
            debounce(e, t) {
                let i;
                return (...s) => {
                    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
                };
            }
            paramUrl(e) {
                return Object.keys(e)
                    .map(function (t) {
                        return t + "=" + encodeURIComponent(e[t]);
                    })
                    .join("&");
            }
        }
        customElements.define("predictive-search", p);
        class f extends HTMLElement {
            constructor() {
                super(),
                    (this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`)),
                    (this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`)),
                    (this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`)),
                    (this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`)),
                    (this.dateInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`)),
                    this.addEventListener("change", () => this.onChange()),
                    (this.recipientFields = this.querySelector(".recipient-fields")),
                    this.checkboxInput.addEventListener("change", () => {
                        this.recipientFields.style.display = this.checkboxInput.checked ? "block" : "none";
                    });
            }
            connectedCallback() {
                document.addEventListener("ajaxProduct:error", (e) => {
                    e.target.querySelector('[name="id"]').value === this.dataset.productVariantId &&
                        this.displayErrorMessage(e.detail.errorMessage);
                }),
                    document.addEventListener("ajaxProduct:added", (e) => {
                        e.target.querySelector('[name="id"]').value === this.dataset.productVariantId &&
                            (this.clearInputFields(), this.clearErrorMessage());
                    });
            }
            onChange() {
                this.checkboxInput.checked || (this.clearInputFields(), this.clearErrorMessage());
            }
            clearInputFields() {
                this.querySelectorAll(".field__input").forEach((e) => (e.value = ""));
            }
            displayErrorMessage(e) {
                if ((this.clearErrorMessage(), e))
                    return Object.entries(e).forEach(([e, t]) => {
                        const i = this[`${e}Input`];
                        i && (i.setAttribute("aria-invalid", !0), i.classList.add("field__input--error"));
                    });
            }
            clearErrorMessage() {
                this.querySelectorAll(".field__input").forEach((e) => {
                    e.setAttribute("aria-invalid", !1),
                        e.removeAttribute("aria-describedby"),
                        e.classList.remove("field__input--error");
                });
            }
        }
        customElements.define("recipient-form", f),
            (theme.announcementBar = (function () {
                var e,
                    t,
                    i = { autoPlay: 5e3, avoidReflow: !0, cellAlign: theme.config.rtl ? "right" : "left" };
                function s() {
                    t = new theme.Slideshow(e, i);
                }
                function n() {
                    t && "function" == typeof t.destroy && t.destroy();
                }
                return {
                    init: function () {
                        (e = document.getElementById("AnnouncementSlider")) &&
                            (n(),
                            1 !== e.dataset.blockCount &&
                                ((theme.config.bpSmall || "true" === e.dataset.compact) && s(),
                                document.addEventListener("matchSmall", function () {
                                    n(), s();
                                }),
                                document.addEventListener("unmatchSmall", function () {
                                    n(), "true" === e.dataset.compact && s();
                                })));
                    },
                    onBlockSelect: function (i) {
                        var s = e.querySelector("#AnnouncementSlide-" + i),
                            n = parseInt(s.dataset.index);
                        t && "function" == typeof t.pause && (t.goToSlide(n), t.pause());
                    },
                    onBlockDeselect: function () {
                        t && "function" == typeof t.play && t.play();
                    },
                    unload: n,
                };
            })()),
            (theme.customerTemplates = function () {
                function e() {
                    document.getElementById("RecoverPasswordForm").classList.toggle("hide"),
                        document.getElementById("CustomerLoginForm").classList.toggle("hide");
                }
                "#recover" === window.location.hash && e(),
                    (function () {
                        var t = document.getElementById("RecoverPassword");
                        t &&
                            t.addEventListener("click", function (t) {
                                t.preventDefault(), e();
                            });
                        var i = document.getElementById("HideRecoverPasswordLink");
                        i &&
                            i.addEventListener("click", function (t) {
                                t.preventDefault(), e();
                            });
                    })(),
                    (function () {
                        if (!document.querySelector(".reset-password-success")) return;
                        document.getElementById("ResetSuccess").classList.remove("hide");
                    })(),
                    (function () {
                        var e = document.getElementById("AddressNewForm"),
                            t = document.querySelectorAll(".js-address-form");
                        if (!e || !t.length) return;
                        setTimeout(function () {
                            document.querySelectorAll(".js-address-country").forEach((e) => {
                                var t = e.dataset.countryId,
                                    i = e.dataset.provinceId,
                                    s = e.dataset.provinceContainerId;
                                new Shopify.CountryProvinceSelector(t, i, { hideElement: s });
                            });
                        }, 1e3),
                            document.querySelectorAll(".address-new-toggle").forEach((t) => {
                                t.addEventListener("click", function () {
                                    e.classList.toggle("hide");
                                });
                            }),
                            document.querySelectorAll(".address-edit-toggle").forEach((e) => {
                                e.addEventListener("click", function (e) {
                                    var t = e.currentTarget.dataset.formId;
                                    document.getElementById("EditAddress_" + t).classList.toggle("hide");
                                });
                            }),
                            document.querySelectorAll(".address-delete").forEach((e) => {
                                e.addEventListener("click", function (e) {
                                    var t = e.currentTarget.dataset.formId,
                                        i = e.currentTarget.dataset.confirmMessage;
                                    confirm(i || "Are you sure you wish to delete this address?") &&
                                        Shopify &&
                                        Shopify.postLink("/account/addresses/" + t, {
                                            parameters: { _method: "delete" },
                                        });
                                });
                            });
                    })();
            }),
            (theme.CartDrawer = (function () {
                var e = "#CartDrawerForm";
                function t() {
                    (this.form = document.querySelector(e)),
                        (this.drawer = new theme.Drawers("CartDrawer", "cart")),
                        this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            (this.cartForm = new theme.CartForm(this.form)),
                                this.cartForm.buildCart(),
                                document.addEventListener(
                                    "ajaxProduct:added",
                                    function (e) {
                                        this.cartForm.buildCart(), this.open();
                                    }.bind(this)
                                ),
                                document.addEventListener("cart:open", this.open.bind(this)),
                                document.addEventListener("cart:close", this.close.bind(this));
                        },
                        open: function () {
                            this.drawer.open(),
                                theme.a11y.trapFocus({
                                    container: this.form,
                                    elementToFocus: this.form,
                                    namespace: "cartdrawer_focus",
                                });
                        },
                        close: function () {
                            this.drawer.close(),
                                theme.a11y.removeTrapFocus({ container: this.form, namespace: "cartdrawer_focus" });
                        },
                    })),
                    t
                );
            })()),
            (theme.headerNav = (function () {
                var e,
                    t,
                    i = {
                        wrapper: "#HeaderWrapper",
                        siteHeader: "#SiteHeader",
                        searchBtn: ".js-search-header",
                        closeSearch: "#SearchClose",
                        searchContainer: ".site-header__search-container",
                        logo: "#LogoContainer img",
                        megamenu: ".megamenu",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                        navDetails: ".site-nav__details",
                    },
                    s = {
                        namespace: ".siteNav",
                        wrapperOverlayed: !1,
                        overlayedClass: "is-light",
                        overlayEnabledClass: "header-wrapper--sticky",
                        stickyEnabled: !1,
                        stickyActive: !1,
                        stickyClass: "site-header--stuck",
                        stickyHeaderWrapper: "StickyHeaderWrap",
                        openTransitionClass: "site-header--opening",
                        lastScroll: 0,
                    };
                function n() {
                    if (s.stickyEnabled) {
                        var e = t.offsetHeight;
                        if (t.classList.contains("site-header--stuck") && !theme.config.bpSmall) {
                            e += 2 * parseFloat(window.getComputedStyle(t, null).getPropertyValue("padding-top"));
                        }
                        document.querySelector("#" + s.stickyHeaderWrapper).style.height = e + "px";
                    }
                }
                function o() {
                    s.stickyEnabled &&
                        (s.forceStopSticky || (requestAnimationFrame(a), (s.lastScroll = window.scrollY)));
                }
                function a() {
                    if (window.scrollY > 250) {
                        if (s.stickyActive) return;
                        (s.stickyActive = !0),
                            t.classList.add(s.stickyClass),
                            s.wrapperOverlayed && e.classList.remove(s.overlayedClass),
                            setTimeout(function () {
                                t.classList.add(s.openTransitionClass);
                            }, 100);
                    } else {
                        if (!s.stickyActive) return;
                        (s.stickyActive = !1),
                            t.classList.remove(s.openTransitionClass),
                            t.classList.remove(s.stickyClass),
                            s.wrapperOverlayed && e.classList.add(s.overlayedClass);
                    }
                }
                return {
                    init: function () {
                        var a;
                        (e = document.querySelector(i.wrapper)),
                            (t = document.querySelector(i.siteHeader)),
                            (s.stickyEnabled = "true" === t.dataset.sticky),
                            s.stickyEnabled &&
                                ((s.wrapperOverlayed = e.classList.contains(s.overlayedClass)),
                                (theme.config.stickyHeader =
                                    ((a = 0),
                                    t.querySelectorAll(i.megamenu).forEach((e) => {
                                        var t = e.offsetHeight;
                                        t > a && (a = t);
                                    }),
                                    !(window.innerHeight < a + 120))),
                                theme.config.stickyHeader
                                    ? ((s.forceStopSticky = !1),
                                      (function () {
                                          s.lastScroll = 0;
                                          var e = document.createElement("div");
                                          (e.id = s.stickyHeaderWrapper),
                                              theme.utils.wrap(t, e),
                                              (function (e) {
                                                  const t = e.closest(
                                                      ".shopify-section-group-header-group"
                                                  ).nextElementSibling;
                                                  if (t && t.classList.contains("shopify-section-group-header-group")) {
                                                      const e = t.offsetHeight;
                                                      document.querySelector(i.wrapper).style.top = e + "px";
                                                  }
                                              })(t),
                                              n(),
                                              window.on("resize" + s.namespace, theme.utils.debounce(50, n)),
                                              window.on("scroll" + s.namespace, theme.utils.throttle(20, o)),
                                              Shopify &&
                                                  Shopify.designMode &&
                                                  setTimeout(function () {
                                                      n();
                                                  }, 250);
                                      })())
                                    : (s.forceStopSticky = !0)),
                            (theme.settings.overlayHeader = "true" === t.dataset.overlay),
                            theme.settings.overlayHeader &&
                                Shopify &&
                                Shopify.designMode &&
                                document.body.classList.contains("template-collection") &&
                                !document.querySelector(".collection-hero") &&
                                this.disableOverlayHeader(),
                            document.querySelectorAll(i.navDetails).forEach((e) => {
                                const t = e.querySelector("summary");
                                document.addEventListener("click", (i) => {
                                    e.hasAttribute("open") && !e.contains(i.target)
                                        ? (e.removeAttribute("open"), t.setAttribute("aria-expanded", "false"))
                                        : e.hasAttribute("open")
                                          ? t.setAttribute("aria-expanded", "false")
                                          : t.setAttribute("aria-expanded", "true");
                                });
                            }),
                            document.querySelectorAll(i.searchBtn).forEach((e) => {
                                e.addEventListener("click", function (e) {
                                    e.preventDefault(),
                                        e.stopPropagation(),
                                        document.dispatchEvent(
                                            new CustomEvent("predictive-search:open", {
                                                detail: { context: "header" },
                                                bubbles: !0,
                                            })
                                        ),
                                        document.querySelector(i.searchContainer).classList.add("is-active");
                                });
                            }),
                            document.addEventListener("predictive-search:close-all", function () {
                                !(function (e) {
                                    if (e)
                                        for (
                                            var t = e.path || (e.composedPath && e.composedPath()), s = 0;
                                            s < t.length;
                                            s++
                                        )
                                            if (t[s].classList) {
                                                if (t[s].classList.contains("site-header__search-btn")) break;
                                                if (t[s].classList.contains("site-header__search-container")) return;
                                            }
                                    document.activeElement.blur(),
                                        document.documentElement.classList.add("js-drawer-closing"),
                                        document.documentElement.classList.remove(
                                            "js-drawer-open",
                                            "js-drawer-open--search"
                                        ),
                                        window.setTimeout(
                                            function () {
                                                document.documentElement.classList.remove("js-drawer-closing");
                                            }.bind(this),
                                            500
                                        );
                                    var n = document.querySelector(i.searchContainer);
                                    theme.utils.prepareTransition(
                                        n,
                                        function () {
                                            n.classList.remove("is-active");
                                        }.bind(this)
                                    );
                                })();
                            });
                    },
                    disableOverlayHeader: function () {
                        e.classList.remove(s.overlayEnabledClass, s.overlayedClass),
                            (s.wrapperOverlayed = !1),
                            (theme.settings.overlayHeader = !1);
                    },
                };
            })()),
            (window.onpageshow = function (e) {
                e.persisted &&
                    (document.body.classList.remove("unloading"),
                    document.querySelectorAll(".cart__checkout").forEach((e) => {
                        e.classList.remove("btn--loading");
                    }));
            }),
            (theme.buildProductGridItem = function (e, t, i, s) {
                var n = "";
                return (
                    e.forEach((e) => {
                        var o = theme.buildProductImage(e, s);
                        let a = "",
                            r = "";
                        theme.settings.predictiveSearchPrice &&
                            (a = `<div class="grid-product__price">${theme.strings.productFrom}${theme.Currency.formatMoney(e.price_min, theme.moneyFormat)}</div>`),
                            theme.settings.predictiveSearchVendor &&
                                (r = `<div class="grid-product__vendor">${e.vendor}</div>`);
                        var c = `\n        <div class="grid__item grid-product ${t} aos-animate" data-aos="row-of-${i}">\n          <div class="grid-product__content">\n            <a href="${e.url}" class="grid-product__link">\n              <div class="grid-product__image-mask">\n                ${o}\n              </div>\n              <div class="grid-product__meta">\n                <div class="grid-product__title">${e.title}</div>\n                ${a}\n                ${r}\n              </div>\n            </a>\n          </div>\n        </div>\n      `;
                        n += c;
                    }),
                    n
                );
            }),
            (theme.buildProductImage = function (e, t) {
                var i = theme.settings.productImageSize,
                    s = "";
                if ("natural" === i) {
                    const i = document.getElementById("naturalImageMarkup").content.cloneNode(!0),
                        o = i.querySelector("img");
                    (i.querySelector(".image-wrap").style.paddingBottom = `${e.image_aspect_ratio}%`), n(o, t);
                    const a = document.createElement("div");
                    a.appendChild(i), (s = a.innerHTML);
                } else {
                    const e = document.getElementById("fixedRatioImageMarkup").content.cloneNode(!0),
                        o = e.querySelector("img");
                    e.querySelector(".grid__image-ratio").classList.add(`grid__image-ratio--${i}`),
                        theme.settings.productImageCover || o.classList.add("grid__image-contain"),
                        n(o, t);
                    const a = document.createElement("div");
                    a.appendChild(e), (s = a.innerHTML);
                }
                function n(t, i) {
                    (t.src = e.image_responsive_url),
                        (t.srcset = e.image_responsive_urls.toString()),
                        (t.alt = e.title),
                        (t.sizes = i);
                }
                return s;
            });
        class g extends HTMLElement {
            constructor() {
                super(),
                    (this.cookieName = this.id),
                    (this.cookie = Cookies.get(this.cookieName)),
                    (this.classes = {
                        activeContent: "age-verification-popup__content--active",
                        inactiveContent: "age-verification-popup__content--inactive",
                        inactiveDeclineContent: "age-verification-popup__decline-content--inactive",
                        activeDeclineContent: "age-verification-popup__decline-content--active",
                    }),
                    (this.declineButton = this.querySelector("[data-age-verification-popup-decline-button]")),
                    (this.declineContent = this.querySelector("[data-age-verification-popup-decline-content]")),
                    (this.content = this.querySelector("[data-age-verification-popup-content]")),
                    (this.returnButton = this.querySelector("[data-age-verification-popup-return-button]")),
                    (this.exitButton = this.querySelector("[data-age-verification-popup-exit-button]")),
                    (this.backgroundImage = this.querySelector("[data-background-image]")),
                    (this.mobileBackgroundImage = this.querySelector("[data-mobile-background-image]")),
                    Shopify.designMode &&
                        (document.addEventListener("shopify:section:select", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.init();
                        }),
                        document.addEventListener("shopify:section:load", (e) => {
                            if (e.detail.sectionId === this.dataset.sectionId) {
                                this.init(),
                                    "true" === this.dataset.testMode && this.cookie && Cookies.remove(this.cookieName);
                                if (!sessionStorage.getItem(this.id)) return;
                                this.showDeclineContent();
                            }
                        }),
                        document.addEventListener("shopify:section:unload", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.modal.close();
                        })),
                    (this.cookie && "false" === this.dataset.testMode) || this.init();
            }
            init() {
                (this.modal = new theme.Modals(this.id, "age-verification-popup-modal", { closeOffContentClick: !1 })),
                    this.backgroundImage && (this.backgroundImage.style.display = "block"),
                    theme.config.bpSmall &&
                        this.mobileBackgroundImage &&
                        (this.mobileBackgroundImage.style.display = "block"),
                    this.modal.open(),
                    theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent")),
                    this.declineButton &&
                        this.declineButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                this.showDeclineContent(),
                                Shopify.designMode && sessionStorage.setItem(this.id, "second-view");
                        }),
                    this.returnButton &&
                        this.returnButton.addEventListener("click", (e) => {
                            e.preventDefault(), this.hideDeclineContent();
                            const t = sessionStorage.getItem(this.id);
                            Shopify.designMode && t && sessionStorage.removeItem(this.id);
                        }),
                    this.exitButton &&
                        this.exitButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                "false" === this.dataset.testMode &&
                                    Cookies.set(this.cookieName, "entered", {
                                        expires: 30,
                                        sameSite: "none",
                                        secure: !0,
                                    }),
                                this.backgroundImage && (this.backgroundImage.style.display = "none"),
                                theme.config.bpSmall &&
                                    this.mobileBackgroundImage &&
                                    (this.mobileBackgroundImage.style.display = "none"),
                                this.modal.close(),
                                theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent"));
                        });
            }
            showDeclineContent() {
                this.declineContent.classList.remove(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.add(this.classes.activeDeclineContent),
                    this.content.classList.add(this.classes.inactiveContent),
                    this.content.classList.remove(this.classes.activeContent);
            }
            hideDeclineContent() {
                this.declineContent.classList.add(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.remove(this.classes.activeDeclineContent),
                    this.content.classList.remove(this.classes.inactiveContent),
                    this.content.classList.add(this.classes.activeContent);
            }
        }
        customElements.define("age-verification-popup", g),
            (theme.Maps = (function () {
                var e = 14,
                    t = null,
                    i = [],
                    s = {},
                    n = '[data-section-type="map"]',
                    o = "[data-map]",
                    a = ".map-section__overlay";
                function r(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.map = e.querySelector(o)),
                        (this.key = this.map.dataset.apiKey),
                        (s = {
                            addressNoResults: theme.strings.addressNoResults,
                            addressQueryLimit: theme.strings.addressQueryLimit,
                            addressError: theme.strings.addressError,
                            authError: theme.strings.authError,
                        }),
                        this.key &&
                            theme.initWhenVisible({
                                element: this.container,
                                callback: this.prepMapApi.bind(this),
                                threshold: 20,
                            });
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode &&
                            (document.querySelectorAll(n).forEach((e) => {
                                e.classList.add("map-section--load-error");
                            }),
                            document.querySelectorAll(o).forEach((e) => {
                                e.parentNode.removeChild(e);
                            }),
                            window.mapError(theme.strings.authError));
                    }),
                    (window.mapError = function (e) {
                        var t = document.createElement("div");
                        t.classList.add("map-section__error", "errors", "text-center"),
                            (t.innerHTML = e),
                            document.querySelectorAll(a).forEach((e) => {
                                e.parentNode.prepend(t);
                            }),
                            document.querySelectorAll(".map-section__link").forEach((e) => {
                                e.classList.add("hide");
                            });
                    }),
                    (r.prototype = Object.assign({}, r.prototype, {
                        prepMapApi: function () {
                            if ("loaded" === t) this.createMap();
                            else if (
                                (i.push(this),
                                "loading" !== t &&
                                    ((t = "loading"), void 0 === window.google || void 0 === window.google.maps))
                            ) {
                                var e = document.createElement("script");
                                (e.onload = function () {
                                    (t = "loaded"),
                                        i.forEach((e) => {
                                            e.createMap();
                                        });
                                }),
                                    (e.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                                    document.head.appendChild(e);
                            }
                        },
                        createMap: function () {
                            var t = this.map;
                            return (function (e) {
                                var t = new google.maps.Geocoder();
                                if (e) {
                                    var i = e.dataset.addressSetting,
                                        s = new Promise((e, s) => {
                                            t.geocode({ address: i }, function (t, i) {
                                                i !== google.maps.GeocoderStatus.OK && s(i), e(t);
                                            });
                                        });
                                    return s;
                                }
                            })(t)
                                .then(
                                    function (i) {
                                        var s = {
                                                zoom: e,
                                                backgroundColor: "none",
                                                center: i[0].geometry.location,
                                                draggable: !1,
                                                clickableIcons: !1,
                                                scrollwheel: !1,
                                                disableDoubleClickZoom: !0,
                                                disableDefaultUI: !0,
                                            },
                                            n = (this.map = new google.maps.Map(t, s)),
                                            o = (this.center = n.getCenter());
                                        new google.maps.Marker({ map: n, position: n.getCenter() });
                                        google.maps.event.addDomListener(
                                            window,
                                            "resize",
                                            theme.utils.debounce(250, function () {
                                                google.maps.event.trigger(n, "resize"),
                                                    n.setCenter(o),
                                                    t.removeAttribute("style");
                                            })
                                        ),
                                            Shopify.designMode && window.AOS && AOS.refreshHard();
                                    }.bind(this)
                                )
                                .catch(function (e) {
                                    var t;
                                    switch (e) {
                                        case "ZERO_RESULTS":
                                            t = s.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            t = s.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            t = s.authError;
                                            break;
                                        default:
                                            t = s.addressError;
                                    }
                                    Shopify.designMode && window.mapError(t);
                                });
                        },
                        onUnload: function () {
                            0 !== this.map.length &&
                                google &&
                                google.maps &&
                                google.maps.event &&
                                google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    r
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function e(e) {
                    this.container = e;
                    var t = this.container.getAttribute("data-section-id");
                    if (
                        ((this.cookieName = "newsletter-" + t),
                        (this.cookie = Cookies.get(this.cookieName)),
                        e && "/challenge" !== window.location.pathname && "/password" !== window.location.pathname)
                    ) {
                        (this.data = {
                            secondsBeforeShow: e.dataset.delaySeconds,
                            daysBeforeReappear: e.dataset.delayDays,
                            hasReminder: e.dataset.hasReminder,
                            testMode: e.dataset.testMode,
                        }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal"));
                        var i = e.querySelector(".popup-cta a");
                        i &&
                            i.addEventListener(
                                "click",
                                function () {
                                    this.closePopup(!0);
                                }.bind(this)
                            ),
                            (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(),
                            e.querySelector(".note--success")
                                ? this.closePopup(!0)
                                : (document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)),
                                  this.cookie || this.initPopupDelay(),
                                  document.addEventListener("reminder:openNewsletter", () => {
                                      this.modal.open();
                                  }));
                    }
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        initPopupDelay: function () {
                            "true" !== this.data.testMode &&
                                setTimeout(
                                    function () {
                                        if ("true" === sessionStorage.getItem("newsletterAppeared")) {
                                            const e = new CustomEvent("newsletter:openReminder", { bubbles: !0 });
                                            this.container.dispatchEvent(e);
                                        } else this.modal.open(), sessionStorage.setItem("newsletterAppeared", !0);
                                    }.bind(this),
                                    1e3 * this.data.secondsBeforeShow
                                );
                        },
                        closePopup: function (e) {
                            if ("true" !== this.data.testMode) {
                                var t = e ? 200 : this.data.daysBeforeReappear,
                                    i = "true" === this.data.hasReminder,
                                    s = "true" === sessionStorage.getItem("reminderAppeared");
                                i && s
                                    ? Cookies.set(this.cookieName, "opened", { path: "/", expires: t })
                                    : i || Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
                            } else Cookies.remove(this.cookieName, { path: "/" });
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                        onBlockSelect: function () {
                            this.modal.close();
                        },
                        onBlockDeselect: function () {
                            this.modal.open();
                        },
                        onUnload: function () {
                            this.modal.close();
                        },
                    })),
                    e
                );
            })()),
            (theme.PasswordHeader = (function () {
                function e() {
                    this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            if (document.querySelector("#LoginModal")) {
                                var e = new theme.Modals("LoginModal", "login-modal", {
                                    focusIdOnOpen: "password",
                                    solid: !0,
                                });
                                document.querySelectorAll(".errors").length && e.open();
                            }
                        },
                    })),
                    e
                );
            })()),
            (theme.Photoswipe = (function () {
                var e = ".js-photoswipe__zoom",
                    t = ".photoswipe__image",
                    i = ".flickity-viewport ",
                    s = ".is-selected";
                function n(e, t) {
                    (this.container = e),
                        (this.sectionId = t),
                        (this.namespace = ".photoswipe-" + this.sectionId),
                        this.gallery,
                        this.images,
                        this.items,
                        (this.inSlideshow = !1),
                        e && "false" !== e.dataset.zoom && this.init();
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function () {
                            this.container.querySelectorAll(e).forEach((e) => {
                                e.on("click" + this.namespace, this.triggerClick.bind(this));
                            });
                        },
                        triggerClick: function (e) {
                            this.container.dataset && "true" === this.container.dataset.hasSlideshow
                                ? (this.inSlideshow = !0)
                                : (this.inSlideshow = !1),
                                (this.items = this.getImageData());
                            var t = this.inSlideshow ? this.container.querySelector(s) : e.currentTarget,
                                i = this.inSlideshow ? this.getChildIndex(t) : t.dataset.index;
                            this.initGallery(this.items, i);
                        },
                        getChildIndex: function (e) {
                            for (var t = 0; null != (e = e.previousSibling); ) t++;
                            return t + 1;
                        },
                        getImageData: function () {
                            this.images = this.inSlideshow
                                ? this.container.querySelectorAll(i + t)
                                : this.container.querySelectorAll(t);
                            var e = [];
                            return (
                                this.images.forEach((t) => {
                                    var i = {
                                        msrc: t.currentSrc || t.src,
                                        src: t.getAttribute("data-photoswipe-src"),
                                        w: t.getAttribute("data-photoswipe-width"),
                                        h: t.getAttribute("data-photoswipe-height"),
                                        el: t,
                                        initialZoomLevel: 0.5,
                                    };
                                    e.push(i);
                                }),
                                e
                            );
                        },
                        initGallery: function (e, t) {
                            var i = document.querySelectorAll(".pswp")[0],
                                s = {
                                    allowPanToNext: !1,
                                    captionEl: !1,
                                    closeOnScroll: !1,
                                    counterEl: !1,
                                    history: !1,
                                    index: t - 1,
                                    pinchToClose: !1,
                                    preloaderEl: !1,
                                    scaleMode: "zoom",
                                    shareEl: !1,
                                    tapToToggleControls: !1,
                                    getThumbBoundsFn: function (t) {
                                        var i = window.pageYOffset || document.documentElement.scrollTop,
                                            s = e[t].el.getBoundingClientRect();
                                        return { x: s.left, y: s.top + i, w: s.width };
                                    },
                                };
                            (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, s)),
                                this.gallery.listen("afterChange", this.afterChange.bind(this)),
                                this.gallery.init(),
                                this.preventiOS15Scrolling();
                        },
                        afterChange: function () {
                            var e = this.gallery.getCurrentIndex();
                            this.container.dispatchEvent(
                                new CustomEvent("photoswipe:afterChange", { detail: { index: e } })
                            );
                        },
                        syncHeight: function () {
                            document.documentElement.style.setProperty(
                                "--window-inner-height",
                                `${window.innerHeight}px`
                            );
                        },
                        preventiOS15Scrolling: function () {
                            let e;
                            /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
                                (this.syncHeight(),
                                (e = window.scrollY),
                                document.documentElement.classList.add("pswp-open-in-ios"),
                                window.addEventListener("resize", this.syncHeight),
                                this.gallery.listen("destroy", () => {
                                    document.documentElement.classList.remove("pswp-open-in-ios"),
                                        window.scrollTo(0, e);
                                }));
                        },
                    })),
                    n
                );
            })());
        class v extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.url = this.dataset.url),
                    (this.intent = this.dataset.intent),
                    (this.placeholder = this.querySelector(".product-recommendations-placeholder")),
                    (this.productResults = this.querySelector(".grid-product")),
                    (this.sectionId = this.dataset.sectionId),
                    (this.blockId = this.dataset.blockId),
                    document.addEventListener("recommendations:loaded", (e) => {
                        (this.colorImages = this.el.querySelectorAll(".grid-product__color-image")),
                            this.colorImages.length &&
                                ((this.swatches = this.el.querySelectorAll(".color-swatch--with-image")),
                                this.colorSwatchHovering());
                    });
            }
            connectedCallback() {
                fetch(this.url)
                    .then((e) => e.text())
                    .then((e) => {
                        const t = document.createElement("div");
                        t.innerHTML = e;
                        const i = t.querySelector(".product-recommendations");
                        if (!i) return this.el.classList.add("hide"), void (AOS && AOS.refreshHard());
                        (this.placeholder.innerHTML = ""),
                            (this.placeholder.innerHTML = i.innerHTML),
                            theme.reinitProductGridItem(this.el),
                            (this.slideshow = this.querySelector("[data-slideshow]")),
                            this.slideshow && this.setupSlider(),
                            document.dispatchEvent(
                                new CustomEvent("recommendations:loaded", {
                                    detail: { section: this.el, intent: this.intent },
                                })
                            );
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            setupSlider() {
                let e = !1,
                    t = !0;
                "arrows" === this.slideshow.dataset.controls && ((t = !1), (e = !0)),
                    parseFloat(this.slideshow.dataset.perSlide) < parseFloat(this.slideshow.dataset.count) &&
                        (this.flickity = new theme.Slideshow(this.slideshow, {
                            prevNextButtons: e,
                            pageDots: t,
                            adaptiveHeight: !0,
                            wrapAround: !1,
                        }));
            }
            colorSwatchHovering() {
                this.swatches.forEach((e) => {
                    e.addEventListener(
                        "mouseenter",
                        function () {
                            this.setActiveColorImage(e);
                        }.bind(this)
                    ),
                        e.addEventListener(
                            "touchstart",
                            function (t) {
                                t.preventDefault(), this.setActiveColorImage(e);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        e.addEventListener(
                            "mouseleave",
                            function () {
                                this.removeActiveColorImage(e);
                            }.bind(this)
                        );
                });
            }
            setActiveColorImage(e) {
                const t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach((e) => {
                    e.classList.remove("is-active");
                }),
                    this.swatches.forEach((e) => {
                        e.classList.remove("is-active");
                    });
                const s = this.el.querySelector(`.grid-product__color-image--${t}`);
                (s.style.backgroundImage = "url(" + i + ")"),
                    s.classList.add("is-active"),
                    e.classList.add("is-active");
                const n = e.dataset.url;
                e.closest(".grid-item__link").setAttribute("href", n);
            }
            removeActiveColorImage(e) {
                const t = e.dataset.variantId;
                this.el.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active");
            }
        }
        customElements.define("product-recommendations", v),
            (theme.SlideshowSection = (function () {
                function e(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    if (
                        ((this.slideshow = e.querySelector("#Slideshow-" + t)),
                        (this.namespace = "." + t),
                        (this.initialIndex = 0),
                        this.slideshow)
                    ) {
                        var i = e.parentElement;
                        0 === [].indexOf.call(i.parentElement.children, i)
                            ? this.init()
                            : theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) });
                    }
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            var e = this.slideshow.querySelectorAll(".slideshow__slide");
                            if (
                                (this.slideshow.classList.remove("loading", "loading--delayed"),
                                this.slideshow.classList.add("loaded"),
                                e.length > 1)
                            ) {
                                var t = {
                                    prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                                    pageDots: this.slideshow.hasAttribute("data-dots"),
                                    fade: !0,
                                    setGallerySize: !1,
                                    initialIndex: this.initialIndex,
                                    autoPlay:
                                        "true" === this.slideshow.dataset.autoplay &&
                                        parseInt(this.slideshow.dataset.speed),
                                };
                                this.flickity = new theme.Slideshow(this.slideshow, t);
                            } else e[0].classList.add("is-selected");
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId),
                                i = parseInt(t.dataset.index);
                            this.flickity && "function" == typeof this.flickity.pause
                                ? (this.flickity.goToSlide(i), this.flickity.pause())
                                : ((this.initialIndex = i),
                                  setTimeout(
                                      function () {
                                          this.flickity &&
                                              "function" == typeof this.flickity.pause &&
                                              this.flickity.pause();
                                      }.bind(this),
                                      1e3
                                  ));
                        },
                        onBlockDeselect: function () {
                            this.flickity &&
                                "function" == typeof this.flickity.play &&
                                this.flickity.args.autoPlay &&
                                this.flickity.play();
                        },
                    })),
                    e
                );
            })()),
            (theme.StoreAvailability = (function () {
                var e = ".js-drawer-open-availability",
                    t = ".js-modal-open-availability",
                    i = "[data-availability-product-title]";
                function s(e) {
                    (this.container = e),
                        (this.baseUrl = e.dataset.baseUrl),
                        (this.productTitle = e.dataset.productName);
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        updateContent: function (s) {
                            var n = this.baseUrl + "/variants/" + s + "/?section_id=store-availability",
                                o = this;
                            fetch(n)
                                .then(function (e) {
                                    return e.text();
                                })
                                .then(function (s) {
                                    if ("" !== s.trim()) {
                                        (o.container.innerHTML = s),
                                            (o.container.innerHTML = o.container.firstElementChild.innerHTML),
                                            o.container.querySelector(e) &&
                                                (o.drawer = new theme.Drawers(
                                                    "StoreAvailabilityDrawer",
                                                    "availability"
                                                )),
                                            o.container.querySelector(t) &&
                                                (o.modal = new theme.Modals("StoreAvailabilityModal", "availability"));
                                        var n = o.container.querySelector(i);
                                        n && (n.textContent = o.productTitle);
                                    } else this.container.innerHTML = "";
                                });
                        },
                    })),
                    s
                );
            })()),
            (theme.VideoSection = (function () {
                var e = ".video-parent-section";
                function t(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".video-" + this.sectionId),
                        this.videoObject,
                        theme.initWhenVisible({
                            element: this.container,
                            callback: this.init.bind(this),
                            threshold: 500,
                        });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            var e = this.container.querySelector(".video-div");
                            if (e)
                                switch (e.dataset.type) {
                                    case "youtube":
                                        var t = e.dataset.videoId;
                                        this.initYoutubeVideo(t);
                                        break;
                                    case "vimeo":
                                        t = e.dataset.videoId;
                                        this.initVimeoVideo(t);
                                        break;
                                    case "mp4":
                                        this.initMp4Video();
                                }
                        },
                        initYoutubeVideo: function (t) {
                            this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
                                videoId: t,
                                videoParent: e,
                            });
                        },
                        initVimeoVideo: function (t) {
                            this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, t, { videoParent: e });
                        },
                        initMp4Video: function () {
                            var t = "Mp4Video-" + this.sectionId,
                                i = document.getElementById(t),
                                s = i.closest(e);
                            if (i) {
                                s.classList.add("loaded");
                                var n = document.querySelector("#" + t).play();
                                void 0 !== n &&
                                    n
                                        .then(function () {})
                                        .catch(function () {
                                            i.setAttribute("controls", ""), s.classList.add("video-interactable");
                                        });
                            }
                        },
                        onUnload: function (e) {
                            e.target.id.replace("shopify-section-", "");
                            this.videoObject &&
                                "function" == typeof this.videoObject.destroy &&
                                this.videoObject.destroy();
                        },
                    })),
                    t
                );
            })());
        class y extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.display = this.querySelector("[data-time-display]")),
                    (this.block = this.closest(".countdown__block--timer")),
                    (this.year = this.el.dataset.year),
                    (this.month = this.el.dataset.month),
                    (this.day = this.el.dataset.day),
                    (this.hour = this.el.dataset.hour),
                    (this.minute = this.el.dataset.minute),
                    (this.daysPlaceholder = this.querySelector("[date-days-placeholder]")),
                    (this.hoursPlaceholder = this.querySelector("[date-hours-placeholder]")),
                    (this.minutesPlaceholder = this.querySelector("[date-minutes-placeholder]")),
                    (this.secondsPlaceholder = this.querySelector("[date-seconds-placeholder]")),
                    (this.messagePlaceholder = this.querySelector("[data-message-placeholder]")),
                    (this.hideTimerOnComplete = this.el.dataset.hideTimer),
                    (this.completeMessage = this.el.dataset.completeMessage),
                    (this.timerComplete = !1),
                    this.init();
            }
            init() {
                setInterval(() => {
                    this.timerComplete || this._calculate();
                }, 1e3);
            }
            _calculate() {
                const e =
                    +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() -
                    +new Date().getTime();
                if (e > 0) {
                    const t = {
                        days: Math.floor(e / 864e5),
                        hours: Math.floor((e / 36e5) % 24),
                        minutes: Math.floor((e / 1e3 / 60) % 60),
                        seconds: Math.floor((e / 1e3) % 60),
                    };
                    (this.daysPlaceholder.innerHTML = t.days),
                        (this.hoursPlaceholder.innerHTML = t.hours),
                        (this.minutesPlaceholder.innerHTML = t.minutes),
                        (this.secondsPlaceholder.innerHTML = t.seconds),
                        setTimeout(() => {
                            this.display.classList.add("countdown__display--loaded");
                        }, 1);
                } else
                    this.completeMessage &&
                        this.messagePlaceholder &&
                        this.messagePlaceholder.classList.add("countdown__timer-message--visible"),
                        "true" === this.hideTimerOnComplete &&
                            (this.display.classList.remove("countdown__display--visible"),
                            this.display.classList.add("countdown__display--hidden")),
                        this.completeMessage ||
                            "true" !== this.hideTimerOnComplete ||
                            this.block.classList.add("countdown__block--hidden"),
                        (this.timerComplete = !0);
            }
        }
        customElements.define("countdown-timer", y);
        class S extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.buttons = this.querySelectorAll("[data-button]")),
                    (this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]")),
                    (this.blockContainer = this.querySelector("[data-block-container]")),
                    (this.colorImages = this.querySelectorAll(".grid-product__color-image")),
                    (this.colorSwatches = this.querySelectorAll(".color-swatch--with-image")),
                    this._bindEvents(),
                    this._setupQuickShop(),
                    this.colorImages.length && this._colorSwatchHovering();
            }
            _colorSwatchHovering() {
                this.colorSwatches.forEach((e) => {
                    e.addEventListener(
                        "mouseenter",
                        function () {
                            this._setActiveColorImage(e);
                        }.bind(this)
                    ),
                        e.addEventListener(
                            "touchstart",
                            function (t) {
                                t.preventDefault(), this._setActiveColorImage(e);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        e.addEventListener(
                            "mouseleave",
                            function () {
                                this._removeActiveColorImage(e);
                            }.bind(this)
                        );
                });
            }
            _setActiveColorImage(e) {
                var t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach((e) => {
                    e.classList.remove("is-active");
                }),
                    this.colorSwatches.forEach((e) => {
                        e.classList.remove("is-active");
                    });
                var s = this.el.querySelector(".grid-product__color-image--" + t);
                (s.style.backgroundImage = "url(" + i + ")"),
                    s.classList.add("is-active"),
                    e.classList.add("is-active");
                var n = e.dataset.url,
                    o = e.closest(".grid-item__link");
                o && o.setAttribute("href", n);
            }
            _removeActiveColorImage(e) {
                const t = e.dataset.variantId;
                this.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active");
            }
            _bindEvents() {
                this.buttons.forEach((e) => {
                    const t = e.dataset.button;
                    e.on("click", (e) => {
                        e.preventDefault(), e.stopPropagation(), this._showContent(t);
                    });
                }),
                    document.addEventListener("shopify:block:select", (e) => {
                        const t = e.detail.blockId;
                        this._showContent(`${t}`);
                    });
            }
            _showContent(e) {
                this.hotspotBlocks.forEach((t) => {
                    t.dataset.hotspotBlock === e ? t.classList.add("is-active") : t.classList.remove("is-active");
                });
            }
            _setupQuickShop() {
                this.querySelectorAll('[data-block-type="product"]').length > 0 &&
                    ("function" == typeof theme.QuickShop
                        ? new theme.QuickShop(this.blockContainer)
                        : "function" == typeof theme.initQuickShop && theme.initQuickShop(),
                    "function" == typeof theme.QuickAdd && new theme.QuickAdd(this.blockContainer));
            }
        }
        customElements.define("hot-spots", S);
        class b extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.sectionId = this.dataset.sectionId),
                    (this.button = this.querySelector("[data-button]")),
                    (this.draggableContainer = this.querySelector("[data-draggable]")),
                    (this.primaryImage = this.querySelector("[data-primary-image]")),
                    (this.secondaryImage = this.querySelector("[data-secondary-image]")),
                    this.calculateSizes(),
                    (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    this.el.addEventListener("touchstart", this.dragStart, !1),
                    this.el.addEventListener("touchend", this.dragEnd, !1),
                    this.el.addEventListener("touchmove", this.drag, !1),
                    this.el.addEventListener("mousedown", this.dragStart, !1),
                    this.el.addEventListener("mouseup", this.dragEnd, !1),
                    this.el.addEventListener("mousemove", this.drag, !1),
                    window.on(
                        "resize",
                        theme.utils.debounce(250, () => {
                            this.calculateSizes(!0);
                        })
                    ),
                    document.addEventListener("shopify:section:load", (e) => {
                        e.detail.sectionId === this.sectionId && null !== this.primaryImage && this.calculateSizes();
                    });
            }
            calculateSizes(e = !1) {
                (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    (this.elWidth = this.el.offsetWidth),
                    (this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`),
                    this.primaryImage && (this.primaryImage.style.width = `${this.elWidth}px`),
                    e && (this.draggableContainer.style.width = this.elWidth / 2 + "px");
            }
            dragStart(e) {
                "touchstart" === e.type
                    ? (this.initialX = e.touches[0].clientX - this.xOffset)
                    : (this.initialX = e.clientX - this.xOffset),
                    e.target === this.button && (this.active = !0);
            }
            dragEnd(e) {
                (this.initialX = this.currentX), (this.active = !1);
            }
            drag(e) {
                this.active &&
                    (e.preventDefault(),
                    "touchmove" === e.type
                        ? (this.currentX = e.touches[0].clientX - this.initialX)
                        : (this.currentX = e.clientX - this.initialX),
                    (this.xOffset = this.currentX),
                    this.setTranslate(this.currentX, this.button));
            }
            setTranslate(e, t) {
                let i = e - this.buttonOffset,
                    s = this.elWidth / 2 + e;
                const n = 50,
                    o = -1 * (this.elWidth / 2 + this.buttonOffset),
                    a = this.elWidth / 2 - this.buttonOffset;
                i < o + n ? ((i = o + n), (s = n)) : i > a - n && ((i = a - n), (s = this.elWidth - n)),
                    (t.style.transform = `translate(${i}px, -50%)`),
                    (this.draggableContainer.style.width = `${s}px`);
            }
        }
        customElements.define("image-compare", b),
            (theme.Blog = (function () {
                function e(e) {
                    this.tagFilters();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        tagFilters: function () {
                            var e = document.getElementById("BlogTagFilter");
                            e &&
                                e.addEventListener("change", function () {
                                    location.href = e.value;
                                });
                        },
                    })),
                    e
                );
            })()),
            (theme.CollectionHeader = (function () {
                var e = !1;
                function t(t) {
                    this.namespace = ".collection-header";
                    var i = t.querySelector(".collection-hero");
                    i
                        ? (e && this.checkIfNeedReload(),
                          i.classList.remove("loading", "loading--delayed"),
                          i.classList.add("loaded"))
                        : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(),
                        (e = !0);
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        checkIfNeedReload: function () {
                            Shopify.designMode &&
                                theme.settings.overlayHeader &&
                                (document
                                    .querySelector(".header-wrapper")
                                    .classList.contains("header-wrapper--overlay") ||
                                    location.reload());
                        },
                    })),
                    t
                );
            })()),
            (theme.CollectionSidebar = (function () {
                var e = !1,
                    t = "#CollectionSidebar";
                function i(e) {
                    this.container = e.querySelector(t);
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            this.container &&
                                (this.onUnload(),
                                (e = "drawer" === this.container.dataset.style),
                                (theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0)));
                        },
                        forceReload: function () {
                            this.init();
                        },
                        onSelect: function () {
                            if (theme.FilterDrawer) {
                                if (!e) return void theme.FilterDrawer.close();
                                (e || theme.config.bpSmall) && theme.FilterDrawer.open();
                            }
                        },
                        onDeselect: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                        onUnload: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                    })),
                    i
                );
            })()),
            (theme.Collection = (function () {
                var e = !1,
                    t = "#SortBy",
                    i = ".grid-product__color-image",
                    s = ".color-swatch--with-image",
                    n = ".collection-grid__wrapper",
                    o = ".collapsible-trigger",
                    a = "#CollectionSidebar",
                    r = ".tag-list--active-tags",
                    c = ".tag-list input",
                    d = ".tag-list a",
                    l = ".filter-form",
                    h = ".collection-filter",
                    u = ".price-range",
                    m = "tag--active",
                    p = "tag--remove",
                    f = "collapsible-content--sidebar",
                    g = "is-open";
                function v(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".collection-" + this.sectionId),
                        (this.sidebar = new theme.CollectionSidebar(e)),
                        (this.context = e.getAttribute("data-context")),
                        (this.ajaxRenderer = new theme.AjaxRenderer({
                            sections: [{ sectionId: this.sectionId, nodeId: "CollectionAjaxContent" }],
                            onReplace: this.onReplaceAjaxContent.bind(this),
                        })),
                        this.init();
                }
                return (
                    (v.prototype = Object.assign({}, v.prototype, {
                        init: function () {
                            this.context && "featured-collection" === this.context
                                ? this.colorSwatchHovering()
                                : (this.initSort(),
                                  this.colorSwatchHovering(),
                                  this.initFilters(),
                                  this.initPriceRange(),
                                  this.sidebar.init());
                        },
                        initSort: function () {
                            (this.sortSelect = document.querySelector(t)),
                                this.sortSelect &&
                                    ((this.defaultSort = this.getDefaultSortValue()),
                                    this.sortSelect.on("change" + this.namespace, this.onSortChange.bind(this)));
                        },
                        getSortValue: function () {
                            return this.sortSelect.value || this.defaultSort;
                        },
                        getDefaultSortValue: function () {
                            return this.sortSelect.getAttribute("data-default-sortby");
                        },
                        onSortChange: function () {
                            (this.queryParams = new URLSearchParams(window.location.search)),
                                this.queryParams.set("sort_by", this.getSortValue()),
                                this.queryParams.delete("page"),
                                (window.location.search = this.queryParams.toString());
                        },
                        colorSwatchHovering: function () {
                            this.container.querySelectorAll(i).length &&
                                this.container.querySelectorAll(s).forEach((e) => {
                                    e.addEventListener("mouseenter", () => {
                                        var t = e.dataset.variantId,
                                            i = e.dataset.variantImage,
                                            s = this.container.querySelector(".grid-product__color-image--" + t);
                                        (s.style.backgroundImage = "url(" + i + ")"), s.classList.add("is-active");
                                    }),
                                        e.addEventListener("mouseleave", () => {
                                            var t = e.dataset.variantId;
                                            this.container
                                                .querySelector(".grid-product__color-image--" + t)
                                                .classList.remove("is-active");
                                        });
                                });
                        },
                        initFilters: function () {
                            document.querySelectorAll(c).length &&
                                (this.bindBackButton(),
                                theme.config.stickyHeader &&
                                    (this.setFilterStickyPosition(),
                                    window.on("resize", theme.utils.debounce(500, this.setFilterStickyPosition))),
                                document.querySelectorAll(d).forEach((e) => {
                                    e.addEventListener("click", this.tagClick.bind(this));
                                }),
                                document.querySelectorAll(l).forEach((e) => {
                                    e.addEventListener("input", this.onFormSubmit.bind(this));
                                }));
                        },
                        initPriceRange: function () {
                            document
                                .querySelectorAll(u)
                                .forEach(
                                    (e) => new theme.PriceRange(e, { onChange: this.renderFromFormData.bind(this) })
                                );
                        },
                        tagClick: function (t) {
                            var i = t.currentTarget;
                            if ((theme.FilterDrawer && theme.FilterDrawer.close(), i.classList.contains("no-ajax")))
                                return;
                            if ((t.preventDefault(), e)) return;
                            e = !0;
                            const s = i.parentNode,
                                n = new URL(i.href);
                            this.renderActiveTag(s, i),
                                this.updateScroll(!0),
                                this.startLoading(),
                                this.renderCollectionPage(n.searchParams);
                        },
                        onFormSubmit: function (t) {
                            var i = t.target;
                            if ((theme.FilterDrawer && theme.FilterDrawer.close(), i.classList.contains("no-ajax")))
                                return;
                            if ((t.preventDefault(), e)) return;
                            e = !0;
                            const s = i.closest("li"),
                                n = i.closest("form"),
                                o = new FormData(n);
                            this.renderActiveTag(s, i),
                                this.updateScroll(!0),
                                this.startLoading(),
                                this.renderFromFormData(o);
                        },
                        fetchOpenCollasibleFilters: function () {
                            return Array.from(document.querySelectorAll(`${a} ${o}.${g}`)).map(
                                (e) => e.dataset.collapsibleId
                            );
                        },
                        renderActiveTag: function (e, t) {
                            const i = e.querySelector(".tag__text");
                            e.classList.contains(m)
                                ? e.classList.remove(m)
                                : (e.classList.add(m),
                                  t.closest("li").classList.contains(p)
                                      ? e.remove()
                                      : document.querySelectorAll(r).forEach((e) => {
                                            const t = document.createElement("li"),
                                                s = document.createElement("a");
                                            t.classList.add("tag", "tag--remove"),
                                                s.classList.add("btn", "btn--small"),
                                                (s.innerText = i.innerText),
                                                t.appendChild(s),
                                                e.appendChild(t);
                                        }));
                        },
                        renderFromFormData: function (e) {
                            const t = new URLSearchParams(e);
                            this.renderCollectionPage(t);
                        },
                        onReplaceAjaxContent: function (e, t) {
                            this.fetchOpenCollasibleFilters().forEach((t) => {
                                e.querySelectorAll(`[data-collapsible-id=${t}]`).forEach(this.openCollapsible);
                            });
                            var i = e.getElementById(t.nodeId);
                            i && (document.getElementById(t.nodeId).innerHTML = i.innerHTML);
                        },
                        openCollapsible: function (e) {
                            e.classList.contains(f) && (e.style.height = "auto"), e.classList.add(g);
                        },
                        renderCollectionPage: function (t, i = !0) {
                            this.ajaxRenderer.renderPage(window.location.pathname, t, i).then(() => {
                                theme.sections.reinit("collection-grid"),
                                    this.updateScroll(!1),
                                    this.initPriceRange(),
                                    theme.reinitProductGridItem(),
                                    document.dispatchEvent(new CustomEvent("collection:reloaded")),
                                    (e = !1);
                            });
                        },
                        bindBackButton: function () {
                            window.off("popstate" + this.namespace),
                                window.on(
                                    "popstate" + this.namespace,
                                    function (e) {
                                        if (e) {
                                            const e = new URL(window.location.href);
                                            this.renderCollectionPage(e.searchParams, !1);
                                        }
                                    }.bind(this)
                                );
                        },
                        updateScroll: function (e) {
                            var t = document.querySelector("[data-scroll-to]"),
                                i = t && t.offsetTop;
                            (theme.config.bpSmall || (i -= 15), theme.config.stickyHeader) &&
                                (i -= document.querySelector(".site-header").offsetHeight);
                            e ? window.scrollTo({ top: i, behavior: "smooth" }) : window.scrollTo({ top: i });
                        },
                        setFilterStickyPosition: function () {
                            var e = document.querySelector(".site-header").offsetHeight;
                            document.querySelector(h).style.top = e + 10 + "px";
                            var t = document.querySelector(".grid__item--sidebar");
                            t && (t.style.top = e + 10 + "px");
                        },
                        forceReload: function () {
                            this.init();
                        },
                        startLoading: function () {
                            document.querySelector(n).classList.add("unload");
                        },
                    })),
                    v
                );
            })()),
            (theme.FooterSection = (function () {
                var e = "[data-disclosure-locale]",
                    t = "[data-disclosure-currency]";
                function i(e) {
                    (this.container = e), (this.localeDisclosure = null), (this.currencyDisclosure = null), this.init();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            var i = this.container.querySelector(e),
                                s = this.container.querySelector(t);
                            i && (this.localeDisclosure = new theme.Disclosure(i)),
                                s && (this.currencyDisclosure = new theme.Disclosure(s));
                            var n = document.querySelector(".footer__newsletter-input");
                            n &&
                                n.addEventListener("keyup", function () {
                                    n.classList.add("footer__newsletter-input--active");
                                }),
                                theme.collapsibles.init(this.container);
                        },
                        onUnload: function () {
                            this.localeDisclosure && this.localeDisclosure.destroy(),
                                this.currencyDisclosure && this.currencyDisclosure.destroy();
                        },
                    })),
                    i
                );
            })()),
            (theme.HeaderSection = (function () {
                var e = "[data-disclosure-locale]",
                    t = "[data-disclosure-currency]";
                function i(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        this.init();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            Shopify &&
                                Shopify.designMode &&
                                (theme.sections.reinit("slideshow-section"),
                                setTimeout(function () {
                                    window.dispatchEvent(new Event("resize"));
                                }, 500)),
                                this.initDrawers(),
                                this.initDisclosures(),
                                theme.headerNav.init(),
                                theme.announcementBar.init(),
                                this.hoverMenu();
                        },
                        hoverMenu: function () {
                            const e = document.querySelectorAll(
                                '[data-section-type="header"] details[data-hover="true"]'
                            );
                            e.forEach((t) => {
                                const i = t.querySelector("summary"),
                                    s = i.dataset.link;
                                i.addEventListener("click", (e) => {
                                    e.preventDefault(), (window.location.href = s);
                                }),
                                    t.addEventListener("focusin", () => {
                                        t.hasAttribute("open") ||
                                            (e.forEach((e) => {
                                                e.removeAttribute("open"), e.setAttribute("aria-expanded", "false");
                                            }),
                                            t.setAttribute("open", ""),
                                            t.setAttribute("aria-expanded", "true"));
                                    }),
                                    t.addEventListener("focusout", () => {
                                        t.hasAttribute("open") &&
                                            !t.matches(":focus-within") &&
                                            (t.removeAttribute("open"), t.setAttribute("aria-expanded", "false"));
                                    }),
                                    t.addEventListener("mouseover", () => {
                                        t.hasAttribute("open") ||
                                            (t.setAttribute("open", ""), t.setAttribute("aria-expanded", "true"));
                                    }),
                                    t.addEventListener("mouseleave", () => {
                                        t.hasAttribute("open") &&
                                            (t.removeAttribute("open"), t.setAttribute("aria-expanded", "false"));
                                    });
                            });
                        },
                        initDisclosures: function () {
                            var i = this.container.querySelector(e),
                                s = this.container.querySelector(t);
                            i && (this.localeDisclosure = new theme.Disclosure(i)),
                                s && (this.currencyDisclosure = new theme.Disclosure(s));
                        },
                        initDrawers: function () {
                            (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                                "drawer" === theme.settings.cartType &&
                                    (document.body.classList.contains("template-cart") || new theme.CartDrawer()),
                                theme.collapsibles.init(document.getElementById("NavDrawer"));
                        },
                        onUnload: function () {
                            theme.NavDrawer.close(),
                                theme.announcementBar.unload(),
                                this.localeDisclosure && this.localeDisclosure.destroy(),
                                this.currencyDisclosure && this.currencyDisclosure.destroy();
                        },
                    })),
                    i
                );
            })()),
            (theme.Product = (function () {
                var e = {},
                    t = "on-sale",
                    i = "disabled",
                    s = "is-modal",
                    n = "hide",
                    o = "inventory--low",
                    a = ".product__video",
                    r = ".product__video-wrapper",
                    c = ".product-main-slide",
                    d = ".is-selected",
                    l = ".starting-slide",
                    h = ".variant-wrapper",
                    u = "[data-product-blocks]",
                    m = "[data-blocks-holder]",
                    p = "[data-dynamic-variants-enabled]";
                function f(e) {
                    this.container = e;
                    var t = (this.sectionId = e.getAttribute("data-section-id")),
                        i = (this.productId = e.getAttribute("data-product-id"));
                    (this.inModal = "true" === e.dataset.modal),
                        this.modal,
                        (this.settings = {
                            enableHistoryState: e.dataset.history || !1,
                            namespace: ".product-" + t,
                            inventory: !1,
                            inventoryThreshold: 10,
                            modalInit: !1,
                            hasImages: !0,
                            imageSetName: null,
                            imageSetIndex: null,
                            currentImageSet: null,
                            imageSize: "620x",
                            currentSlideIndex: 0,
                            videoLooping: e.dataset.videoLooping,
                        }),
                        this.inModal &&
                            ((this.settings.enableHistoryState = !1),
                            (this.settings.namespace = ".product-" + t + "-modal"),
                            (this.modal = document.getElementById("QuickShopModal-" + i))),
                        (this.selectors = {
                            variantsJson: "[data-variant-json]",
                            currentVariantJson: "[data-current-variant-json]",
                            form: ".product-single__form",
                            media: "[data-product-media-type-model]",
                            closeMedia: ".product-single__close-media",
                            photoThumbs: "[data-product-thumb]",
                            thumbSlider: "[data-product-thumbs]",
                            thumbScroller: ".product__thumbs--scroller",
                            mainSlider: "[data-product-photos]",
                            imageContainer: "[data-product-images]",
                            productImageMain: "[data-product-image-main]",
                            priceWrapper: "[data-product-price-wrap]",
                            price: "[data-product-price]",
                            comparePrice: "[data-compare-price]",
                            savePrice: "[data-save-price]",
                            priceA11y: "[data-a11y-price]",
                            comparePriceA11y: "[data-compare-price-a11y]",
                            unitWrapper: "[data-unit-price-wrapper]",
                            unitPrice: "[data-unit-price]",
                            unitPriceBaseUnit: "[data-unit-base]",
                            sku: "[data-sku]",
                            inventory: "[data-product-inventory]",
                            incomingInventory: "[data-incoming-inventory]",
                            colorLabel: "[data-variant-color-label]",
                            addToCart: "[data-add-to-cart]",
                            addToCartText: "[data-add-to-cart-text]",
                            originalSelectorId: "[data-product-select]",
                            singleOptionSelector: "[data-variant-input]",
                            variantColorSwatch: ".variant__input--color-swatch",
                            dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
                            availabilityContainer: "[data-store-availability-holder]",
                        }),
                        this.cacheElements(),
                        (this.firstProductImage = this.cache.mainSlider.querySelector("img")),
                        this.firstProductImage || (this.settings.hasImages = !1);
                    var s = this.cache.mainSlider.querySelector("[data-set-name]");
                    s && (this.settings.imageSetName = s.dataset.setName), this.init();
                }
                return (
                    (f.prototype = Object.assign({}, f.prototype, {
                        init: function () {
                            this.inModal &&
                                (this.container.classList.add(s),
                                document.addEventListener(
                                    "modalOpen.QuickShopModal-" + this.productId,
                                    this.openModalProduct.bind(this)
                                ),
                                document.addEventListener(
                                    "modalClose.QuickShopModal-" + this.productId,
                                    this.closeModalProduct.bind(this)
                                )),
                                this.inModal ||
                                    (this.formSetup(),
                                    this.productSetup(),
                                    this.videoSetup(),
                                    this.initProductSlider(),
                                    this.customMediaListners(),
                                    this.addIdToRecentlyViewed());
                        },
                        cacheElements: function () {
                            this.cache = {
                                form: this.container.querySelector(this.selectors.form),
                                mainSlider: this.container.querySelector(this.selectors.mainSlider),
                                thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
                                thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
                                productImageMain: this.container.querySelector(this.selectors.productImageMain),
                                priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
                                comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
                                comparePrice: this.container.querySelector(this.selectors.comparePrice),
                                price: this.container.querySelector(this.selectors.price),
                                savePrice: this.container.querySelector(this.selectors.savePrice),
                                priceA11y: this.container.querySelector(this.selectors.priceA11y),
                            };
                        },
                        formSetup: function () {
                            this.initQtySelector(),
                                this.initAjaxProductForm(),
                                this.availabilitySetup(),
                                this.initVariants(),
                                this.settings.imageSetName && this.updateImageSet();
                        },
                        availabilitySetup: function () {
                            var e = this.container.querySelector(this.selectors.availabilityContainer);
                            e && (this.storeAvailability = new theme.StoreAvailability(e));
                        },
                        productSetup: function () {
                            this.setImageSizes(),
                                this.initImageZoom(),
                                this.initModelViewerLibraries(),
                                this.initShopifyXrLaunch();
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var e = this.firstProductImage.currentSrc;
                                e && (this.settings.imageSize = theme.Images.imageSize(e));
                            }
                        },
                        addIdToRecentlyViewed: function () {
                            var e = this.container.getAttribute("data-product-handle"),
                                t = this.container.getAttribute("data-product-url"),
                                i = this.container.getAttribute("data-aspect-ratio"),
                                s = this.container.getAttribute("data-img-url");
                            theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e],
                                (theme.recentlyViewed.recent[e] = { url: t, aspectRatio: i, featuredImage: s }),
                                theme.config.hasLocalStorage &&
                                    window.localStorage.setItem(
                                        "theme-recent",
                                        JSON.stringify(theme.recentlyViewed.recent)
                                    );
                        },
                        initVariants: function () {
                            var e = this.container.querySelector(this.selectors.variantsJson);
                            if (e) {
                                this.variantsObject = JSON.parse(e.innerHTML);
                                var t = !!this.container.querySelector(p),
                                    i = {
                                        container: this.container,
                                        enableHistoryState: this.settings.enableHistoryState,
                                        singleOptionSelector: this.selectors.singleOptionSelector,
                                        originalSelectorId: this.selectors.originalSelectorId,
                                        variants: this.variantsObject,
                                        dynamicVariantsEnabled: t,
                                    },
                                    s = this.container.querySelectorAll(this.selectors.variantColorSwatch);
                                if (
                                    (s.length &&
                                        s.forEach((e) => {
                                            e.addEventListener(
                                                "updateSwatch",
                                                function (t) {
                                                    var i = e.dataset.colorName,
                                                        s = e.dataset.colorIndex;
                                                    this.updateColorName(i, s);
                                                }.bind(this)
                                            );
                                        }),
                                    (this.variants = new theme.Variants(i)),
                                    this.storeAvailability)
                                ) {
                                    var n = this.variants.currentVariant
                                        ? this.variants.currentVariant.id
                                        : this.variants.variants[0].id;
                                    this.storeAvailability.updateContent(n),
                                        this.container.on(
                                            "variantChange" + this.settings.namespace,
                                            this.updateAvailability.bind(this)
                                        );
                                }
                                this.container.on(
                                    "variantChange" + this.settings.namespace,
                                    this.updateCartButton.bind(this)
                                ),
                                    this.container.on(
                                        "variantImageChange" + this.settings.namespace,
                                        this.updateVariantImage.bind(this)
                                    ),
                                    this.container.on(
                                        "variantPriceChange" + this.settings.namespace,
                                        this.updatePrice.bind(this)
                                    ),
                                    this.container.on(
                                        "variantUnitPriceChange" + this.settings.namespace,
                                        this.updateUnitPrice.bind(this)
                                    ),
                                    this.container.querySelector(this.selectors.sku) &&
                                        this.container.on(
                                            "variantSKUChange" + this.settings.namespace,
                                            this.updateSku.bind(this)
                                        );
                                var o = this.container.querySelector(this.selectors.inventory);
                                if (
                                    (o &&
                                        ((this.settings.inventory = !0),
                                        (this.settings.inventoryThreshold = o.dataset.threshold),
                                        this.updateInventory({ detail: { variant: this.variants.currentVariant } }),
                                        this.container.on(
                                            "variantChange" + this.settings.namespace,
                                            this.updateInventory.bind(this)
                                        )),
                                    t)
                                ) {
                                    var a = this.container.querySelector(this.selectors.currentVariantJson);
                                    if (a) {
                                        var r = this.container.querySelector(h);
                                        r &&
                                            new theme.VariantAvailability({
                                                container: this.container,
                                                namespace: this.settings.namespace,
                                                type: r.dataset.type,
                                                variantsObject: this.variantsObject,
                                                currentVariantObject: JSON.parse(a.innerHTML),
                                            });
                                    }
                                }
                                if (this.settings.imageSetName) {
                                    var c = this.container.querySelector(
                                        '.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]'
                                    );
                                    c
                                        ? ((this.settings.imageSetIndex = c.dataset.index),
                                          this.container.on(
                                              "variantChange" + this.settings.namespace,
                                              this.updateImageSet.bind(this)
                                          ))
                                        : (this.settings.imageSetName = null);
                                }
                            }
                        },
                        initQtySelector: function () {
                            this.container.querySelectorAll(".js-qty__wrapper").forEach((e) => {
                                new theme.QtySelector(e, { namespace: ".product" });
                            });
                        },
                        initAjaxProductForm: function () {
                            new theme.AjaxProduct(this.cache.form);
                        },
                        updateColorName: function (e, t) {
                            this.container.querySelector(this.selectors.colorLabel + `[data-index="${t}"`).textContent =
                                e;
                        },
                        updateCartButton: function (e) {
                            var t = e.detail.variant,
                                s = this.container.querySelector(this.selectors.addToCart),
                                n = this.container.querySelector(this.selectors.addToCartText);
                            if (s)
                                if (t)
                                    if (t.available) {
                                        s.classList.remove(i), (s.disabled = !1);
                                        var o = n.dataset.defaultText;
                                        n.textContent = o;
                                    } else
                                        s.classList.add(i), (s.disabled = !0), (n.textContent = theme.strings.soldOut);
                                else s.classList.add(i), (s.disabled = !0), (n.textContent = theme.strings.unavailable);
                        },
                        updatePrice: function (e) {
                            var i = e.detail.variant;
                            if (i)
                                if (
                                    ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                                        i.price,
                                        theme.settings.moneyFormat
                                    )),
                                    i.compare_at_price > i.price)
                                ) {
                                    (this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
                                        i.compare_at_price,
                                        theme.settings.moneyFormat
                                    )),
                                        this.cache.priceWrapper.classList.remove(n),
                                        this.cache.price.classList.add(t),
                                        this.cache.comparePriceA11y.setAttribute("aria-hidden", "false"),
                                        this.cache.priceA11y.setAttribute("aria-hidden", "false");
                                    var s = i.compare_at_price - i.price;
                                    (s =
                                        "percent" == theme.settings.saveType
                                            ? Math.round((100 * s) / i.compare_at_price) + "%"
                                            : theme.Currency.formatMoney(s, theme.settings.moneyFormat)),
                                        this.cache.savePrice.classList.remove(n),
                                        (this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
                                            "[saved_amount]",
                                            s
                                        ));
                                } else
                                    this.cache.priceWrapper && this.cache.priceWrapper.classList.add(n),
                                        this.cache.savePrice.classList.add(n),
                                        this.cache.price.classList.remove(t),
                                        this.cache.comparePriceA11y &&
                                            this.cache.comparePriceA11y.setAttribute("aria-hidden", "true"),
                                        this.cache.priceA11y.setAttribute("aria-hidden", "true");
                        },
                        updateUnitPrice: function (e) {
                            var t = e.detail.variant;
                            t && t.unit_price
                                ? ((this.container.querySelector(this.selectors.unitPrice).innerHTML =
                                      theme.Currency.formatMoney(t.unit_price, theme.settings.moneyFormat)),
                                  (this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML =
                                      theme.Currency.getBaseUnit(t)),
                                  this.container.querySelector(this.selectors.unitWrapper).classList.remove(n))
                                : this.container.querySelector(this.selectors.unitWrapper).classList.add(n);
                        },
                        imageSetArguments: function (e) {
                            if ((e = e || (this.variants ? this.variants.currentVariant : null))) {
                                var t = (this.settings.currentImageSet = this.getImageSetName(
                                        e[this.settings.imageSetIndex]
                                    )),
                                    i = this.settings.imageSetName + "_" + t;
                                return (
                                    (this.settings.currentSlideIndex = 0),
                                    {
                                        cellSelector: '[data-group="' + i + '"]',
                                        imageSet: i,
                                        initialIndex: this.settings.currentSlideIndex,
                                    }
                                );
                            }
                        },
                        updateImageSet: function (e) {
                            var t = e ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                            if (t) {
                                var i = this.getImageSetName(t[this.settings.imageSetIndex]);
                                this.settings.currentImageSet !== i && this.initProductSlider(t);
                            }
                        },
                        updateImageSetThumbs: function (e) {
                            this.cache.thumbSlider.querySelectorAll(".product__thumb-item").forEach((t) => {
                                t.classList.toggle(n, t.dataset.group !== e);
                            });
                        },
                        getImageSetName: function (e) {
                            return e
                                .toLowerCase()
                                .replace(/[^a-z0-9]+/g, "-")
                                .replace(/-$/, "")
                                .replace(/^-/, "");
                        },
                        updateSku: function (e) {
                            var t = e.detail.variant,
                                i = "";
                            t &&
                                (t.sku && (i = t.sku),
                                (this.container.querySelector(this.selectors.sku).textContent = i));
                        },
                        updateInventory: function (e) {
                            var t = e.detail.variant;
                            if (!t)
                                return (
                                    this.toggleInventoryQuantity("hidden", !1), void this.toggleIncomingInventory(!1)
                                );
                            if (!t.inventory_management)
                                return (
                                    this.toggleInventoryQuantity("visible", !1), void this.toggleIncomingInventory(!1)
                                );
                            if (
                                "shopify" === t.inventory_management &&
                                window.inventories &&
                                window.inventories[this.productId]
                            ) {
                            
                                const e = window.inventories[this.productId][t.id],
                                    { quantity: i, policy: s, incoming: n, next_incoming_date: o } = e || {};

                                    window.currentVariantQty = i;
                                this.toggleInventoryQuantity(void 0, i);
                                const a = document.querySelector(".notify-wrapper"),
                                    r = document.querySelector(".notify-body"),
                                    c = a.getAttribute("data-product-title"),
                                     bundleBtnText = document.querySelector(".bundle-add-to-cart-btn"),
                                     shiprockbtn = document.querySelector(".payment-buttons");
                                
                              if (i > 0) {
                                // In stock
                                a && a.classList.add("hide");
                                if (shiprockbtn) {
                                shiprockbtn.classList.remove("disabled-btn");
                                }

                                if (bundleBtnText) {
                                  bundleBtnText.textContent = "Add to Cart";
                                  console.log("bundletext", bundleBtnText);
                                }

                              } else {
                                // Out of stock
                                a && a.classList.remove("hide");
                                r.value = `Please notify me when ${c} (${t.title}) is back in stock.`;
                                         
                                if (shiprockbtn) {
                                shiprockbtn.classList.add("disabled-btn");
                                }
                                if (bundleBtnText) {
                                  bundleBtnText.textContent = "Sold Out";
                                  console.log("bundletext", bundleBtnText);
                                }
                              }

                              (n && !t.available) || (i <= 0 && "continue" === s)
                                ? this.toggleIncomingInventory(!0, o, s)
                                : this.toggleIncomingInventory(!1);
                            }
                        },
                        updateAvailability: function (e) {
                            var t = e.detail.variant;
                            t && this.storeAvailability.updateContent(t.id);
                        },
                        toggleInventoryQuantity: function (e = void 0, t) {
                            const i = this.container.querySelector(this.selectors.inventory),
                                s = i.closest(".sales-point");
                            if (e && "hidden" === e) return void (s && s.classList.add(n));
                            let a = !1;
                            parseInt(t) <= parseInt(this.settings.inventoryThreshold) && parseInt(t) > 0 && (a = !0),
                                parseInt(t) > 0 || (e && "visible" === e)
                                    ? (a
                                          ? (i.parentNode.classList.add(o),
                                            (i.textContent =
                                                t > 1
                                                    ? theme.strings.otherStockLabel.replace("[count]", t)
                                                    : theme.strings.oneStockLabel.replace("[count]", t)))
                                          : (i.parentNode.classList.remove(o),
                                            (i.textContent = theme.strings.inStockLabel)),
                                      s && s.classList.remove(n))
                                    : s && s.classList.add(n);
                        },
                        toggleIncomingInventory: function (e, t, i) {
                            const s = this.container.querySelector(this.selectors.incomingInventory),
                                a = s.querySelector(".icon-and-text");
                            if (!s) return;
                            const r = "true" === s.dataset.enabled,
                                c = s.querySelector(".js-incoming-text");
                            r && e
                                ? (t
                                      ? ((c.textContent = theme.strings.willBeInStockAfter.replace("[date]", t)),
                                        s.classList.remove(n))
                                      : ((c.textContent = theme.strings.waitingForStock), s.classList.remove(n)),
                                  a && ("continue" !== i ? a.classList.add(o) : a.classList.remove(o)))
                                : s.classList.add(n);
                        },
                        videoSetup: function () {
                            var e = this.cache.mainSlider.querySelectorAll(a);
                            if (!e.length) return !1;
                            e.forEach((e) => {
                                var t = e.dataset.videoType;
                                "youtube" === t
                                    ? this.initYoutubeVideo(e)
                                    : "vimeo" === t
                                      ? this.initVimeoVideo(e)
                                      : "mp4" === t && this.initMp4Video(e);
                            });
                        },
                        initYoutubeVideo: function (t) {
                            e[t.id] = new theme.YouTube(t.id, {
                                videoId: t.dataset.videoId,
                                videoParent: r,
                                autoplay: !1,
                                style: t.dataset.videoStyle,
                                loop: t.dataset.videoLoop,
                                events: {
                                    onReady: this.youtubePlayerReady.bind(this),
                                    onStateChange: this.youtubePlayerStateChange.bind(this),
                                },
                            });
                        },
                        initVimeoVideo: function (t) {
                            e[t.id] = new theme.VimeoPlayer(t.id, t.dataset.videoId, {
                                videoParent: r,
                                autoplay: !1,
                                style: t.dataset.videoStyle,
                                loop: t.dataset.videoLoop,
                            });
                        },
                        youtubePlayerReady: function (t) {
                            var i = t.target.getIframe().id;
                            if (e[i]) {
                                var s = e[i],
                                    n = s.videoPlayer;
                                "sound" !== s.options.style && n.mute(),
                                    s.parent.classList.remove("loading"),
                                    s.parent.classList.add("loaded"),
                                    s.parent.classList.add("video-interactable"),
                                    this._isFirstSlide(i) && "sound" !== s.options.style && n.playVideo();
                            }
                        },
                        _isFirstSlide: function (e) {
                            return this.cache.mainSlider.querySelector(l + " #" + e);
                        },
                        youtubePlayerStateChange: function (t) {
                            var i = t.target.getIframe().id,
                                s = e[i];
                            switch (t.data) {
                                case -1:
                                    s.attemptedToPlay && s.parent.classList.add("video-interactable");
                                    break;
                                case 0:
                                    s && "true" === s.options.loop && s.videoPlayer.playVideo();
                                    break;
                                case 3:
                                    s.attemptedToPlay = !0;
                            }
                        },
                        initMp4Video: function (t) {
                            (e[t.id] = { id: t.id, type: "mp4" }), this._isFirstSlide(t.id) && this.playMp4Video(t.id);
                        },
                        stopVideos: function () {
                            for (var [t, i] of Object.entries(e))
                                i.videoPlayer
                                    ? "function" == typeof i.videoPlayer.stopVideo && i.videoPlayer.stopVideo()
                                    : "mp4" === i.type && this.stopMp4Video(i.id);
                        },
                        _getVideoType: function (e) {
                            return e.getAttribute("data-video-type");
                        },
                        _getVideoDivId: function (e) {
                            return e.id;
                        },
                        playMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e),
                                i = t.play();
                            void 0 !== i &&
                                i
                                    .then(function () {})
                                    .catch(function (e) {
                                        t.setAttribute("controls", ""),
                                            t.closest(r).setAttribute("data-video-style", "unmuted");
                                    });
                        },
                        stopMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e);
                            t && "function" == typeof t.pause && t.pause();
                        },
                        initImageZoom: function () {
                            var e = this.container.querySelector(this.selectors.imageContainer);
                            if (e) {
                                new theme.Photoswipe(e, this.sectionId);
                                e.addEventListener(
                                    "photoswipe:afterChange",
                                    function (e) {
                                        this.flickity && this.flickity.goToSlide(e.detail.index);
                                    }.bind(this)
                                );
                            }
                        },
                        getThumbIndex: function (e) {
                            return e.dataset.index;
                        },
                        updateVariantImage: function (e) {
                            var t = e.detail.variant,
                                i =
                                    (theme.Images.getSizedImageUrl(
                                        t.featured_media.preview_image.src,
                                        this.settings.imageSize
                                    ),
                                    this.container.querySelector(
                                        '.product__thumb[data-id="' + t.featured_media.id + '"]'
                                    )),
                                s = this.getThumbIndex(i);
                            void 0 !== s && this.flickity && this.flickity.goToSlide(s);
                        },
                        initProductSlider: function (e) {
                            if (this.cache.mainSlider.querySelectorAll(c).length <= 1) {
                                var t = this.cache.mainSlider.querySelector(c);
                                t && t.classList.add("is-selected");
                            } else {
                                if (
                                    (this.flickity &&
                                        "function" == typeof this.flickity.destroy &&
                                        this.flickity.destroy(),
                                    !e)
                                ) {
                                    var i = this.cache.mainSlider.querySelector(l);
                                    this.settings.currentSlideIndex = this._slideIndex(i);
                                }
                                var s = {
                                    dragThreshold: 25,
                                    adaptiveHeight: !0,
                                    avoidReflow: !0,
                                    initialIndex: this.settings.currentSlideIndex,
                                    childNav: this.cache.thumbSlider,
                                    childNavScroller: this.cache.thumbScroller,
                                    childVertical: "beside" === this.cache.thumbSlider.dataset.position,
                                    pageDots: !0,
                                    wrapAround: !0,
                                    callbacks: {
                                        onInit: this.onSliderInit.bind(this),
                                        onChange: this.onSlideChange.bind(this),
                                    },
                                };
                                if (this.settings.imageSetName) {
                                    var n = this.imageSetArguments(e);
                                    (s = Object.assign({}, s, n)), this.updateImageSetThumbs(s.imageSet);
                                }
                                this.flickity = new theme.Slideshow(this.cache.mainSlider, s);
                            }
                        },
                        onSliderInit: function (e) {
                            this.settings.imageSetName && this.prepMediaOnSlide(e);
                        },
                        onSlideChange: function (e) {
                            if (this.flickity) {
                                var t = this.cache.mainSlider.querySelector(
                                        '.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'
                                    ),
                                    i = this.settings.imageSetName
                                        ? this.cache.mainSlider.querySelectorAll(
                                              ".flickity-slider .product-main-slide"
                                          )[e]
                                        : this.cache.mainSlider.querySelector(
                                              '.product-main-slide[data-index="' + e + '"]'
                                          );
                                t.setAttribute("tabindex", "-1"),
                                    i.setAttribute("tabindex", 0),
                                    this.stopMediaOnSlide(t),
                                    this.prepMediaOnSlide(i),
                                    (this.settings.currentSlideIndex = e);
                            }
                        },
                        stopMediaOnSlide(t) {
                            var i = t.querySelector(a);
                            if (i) {
                                var s = this._getVideoType(i),
                                    n = this._getVideoDivId(i);
                                if ("youtube" === s) {
                                    if (e[n].videoPlayer) return void e[n].videoPlayer.stopVideo();
                                } else if ("mp4" === s) return void this.stopMp4Video(n);
                            }
                            var o = t.querySelector(this.selectors.media);
                            o && o.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                        },
                        prepMediaOnSlide(t) {
                            var i = t.querySelector(a);
                            if (i) {
                                this.flickity.reposition();
                                var s = this._getVideoType(i),
                                    n = this._getVideoDivId(i);
                                if ("youtube" === s) {
                                    if (e[n].videoPlayer && "sound" !== e[n].options.style)
                                        return void e[n].videoPlayer.playVideo();
                                } else "mp4" === s && this.playMp4Video(n);
                            }
                            var o = t.querySelector(this.selectors.media);
                            o &&
                                (o.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                                t.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0),
                                t.querySelector(".product-single__close-media").setAttribute("tabindex", 0));
                        },
                        _slideIndex: function (e) {
                            return e.getAttribute("data-index");
                        },
                        openModalProduct: function () {
                            var e = !1;
                            if (this.settings.modalInit) e = !0;
                            else {
                                this.blocksHolder = this.container.querySelector(m);
                                var t = this.blocksHolder.dataset.url;
                                fetch(t)
                                    .then(function (e) {
                                        return e.text();
                                    })
                                    .then(
                                        function (e) {
                                            var t = new DOMParser().parseFromString(e, "text/html").querySelector(u);
                                            t.querySelectorAll("[id]").forEach((e) => {
                                                var i = e.getAttribute("id");
                                                e.setAttribute("id", i + "-modal");
                                                var s = t.querySelector(`[for="${i}"]`);
                                                s && s.setAttribute("for", i + "-modal");
                                                var n = t.querySelector(`[aria-controls="${i}"]`);
                                                n && n.setAttribute("aria-controls", i + "-modal");
                                            });
                                            var i = t.querySelector(this.selectors.form);
                                            if (i) {
                                                var s = i.getAttribute("id");
                                                t.querySelectorAll("[form]").forEach((e) => {
                                                    e.setAttribute("form", s);
                                                });
                                            }
                                            (this.blocksHolder.innerHTML = ""),
                                                this.blocksHolder.append(t),
                                                this.blocksHolder.classList.add("product-form-holder--loaded"),
                                                this.cacheElements(),
                                                this.formSetup(),
                                                this.updateModalProductInventory(),
                                                Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                                theme.collapsibles.init(this.container),
                                                document.dispatchEvent(
                                                    new CustomEvent("quickview:loaded", {
                                                        detail: { productId: this.productId },
                                                    })
                                                );
                                        }.bind(this)
                                    ),
                                    this.productSetup(),
                                    this.videoSetup(),
                                    this.settings.imageSetName
                                        ? this.variants
                                            ? this.initProductSlider()
                                            : document.addEventListener(
                                                  "quickview:loaded",
                                                  function (e) {
                                                      e.detail.productId === this.productId && this.initProductSlider();
                                                  }.bind(this)
                                              )
                                        : this.initProductSlider(),
                                    this.customMediaListners(),
                                    this.addIdToRecentlyViewed(),
                                    (this.settings.modalInit = !0);
                            }
                            AOS.refreshHard(),
                                document.dispatchEvent(
                                    new CustomEvent("quickview:open", {
                                        detail: { initialized: e, productId: this.productId },
                                    })
                                );
                        },
                        updateModalProductInventory: function () {
                            (window.inventories = window.inventories || {}),
                                this.container.querySelectorAll(".js-product-inventory-data").forEach((e) => {
                                    var t = e.dataset.productId;
                                    (window.inventories[t] = {}),
                                        e.querySelectorAll(".js-variant-inventory-data").forEach((e) => {
                                            window.inventories[t][e.dataset.id] = {
                                                quantity: e.dataset.quantity,
                                                policy: e.dataset.policy,
                                                incoming: e.dataset.incoming,
                                                next_incoming_date: e.dataset.date,
                                            };
                                        });
                                });
                        },
                        closeModalProduct: function () {
                            this.stopVideos();
                        },
                        initModelViewerLibraries: function () {
                            var e = this.container.querySelectorAll(this.selectors.media);
                            e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
                        },
                        initShopifyXrLaunch: function () {
                            document.addEventListener(
                                "shopify_xr_launch",
                                function () {
                                    this.container
                                        .querySelector(
                                            this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")"
                                        )
                                        .dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                                }.bind(this)
                            );
                        },
                        customMediaListners: function () {
                            document.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                                e.addEventListener(
                                    "click",
                                    function () {
                                        var e = this.cache.mainSlider
                                            .querySelector(d)
                                            .querySelector(this.selectors.media);
                                        e &&
                                            e.dispatchEvent(
                                                new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })
                                            );
                                    }.bind(this)
                                );
                            });
                            var e = this.container.querySelectorAll("model-viewer");
                            e.length &&
                                e.forEach((e) => {
                                    e.addEventListener(
                                        "shopify_model_viewer_ui_toggle_play",
                                        function (e) {
                                            this.mediaLoaded(e);
                                        }.bind(this)
                                    ),
                                        e.addEventListener(
                                            "shopify_model_viewer_ui_toggle_pause",
                                            function (e) {
                                                this.mediaUnloaded(e);
                                            }.bind(this)
                                        );
                                });
                        },
                        mediaLoaded: function (e) {
                            this.container.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                                e.classList.remove(n);
                            }),
                                this.flickity && this.flickity.setDraggable(!1);
                        },
                        mediaUnloaded: function (e) {
                            this.container.querySelectorAll(this.selectors.closeMedia).forEach((e) => {
                                e.classList.add(n);
                            }),
                                this.flickity && this.flickity.setDraggable(!0);
                        },
                        onUnload: function () {
                            theme.ProductMedia.removeSectionModels(this.sectionId),
                                this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                    })),
                    f
                );
            })()),
            (theme.RecentlyViewed = (function () {
                var e = !1;
                function t(e) {
                    e &&
                        ((this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".recently-viewed" + this.sectionId),
                        (this.gridItemWidth = this.container.getAttribute("data-grid-item-class")),
                        (this.rowOf = this.container.getAttribute("data-row-of")),
                        (this.imageSizes = this.container.getAttribute("data-image-sizes")),
                        theme.initWhenVisible({
                            element: this.container,
                            callback: this.init.bind(this),
                            threshold: 600,
                        }));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            if (!e)
                                if (
                                    ((e = !0),
                                    0 !== Object.keys(theme.recentlyViewed.recent).length ||
                                        theme.recentlyViewed.recent.constructor !== Object)
                                ) {
                                    (this.outputContainer = document.getElementById(
                                        "RecentlyViewed-" + this.sectionId
                                    )),
                                        (this.handle = this.container.getAttribute("data-product-handle"));
                                    var t = [];
                                    Object.keys(theme.recentlyViewed.recent).forEach(
                                        function (e) {
                                            "undefined" !== e && t.push(this.getProductInfo(e));
                                        }.bind(this)
                                    ),
                                        Promise.all(t).then(
                                            function (e) {
                                                this.setupOutput(e), this.captureProductDetails(e);
                                            }.bind(this)
                                        );
                                } else this.container.classList.add("hide");
                        },
                        getProductInfo: function (e) {
                            return new Promise(function (t, i) {
                                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                                    ? t(theme.recentlyViewed.productInfo[e])
                                    : fetch("/products/" + e + ".js")
                                          .then(function (e) {
                                              return e.text();
                                          })
                                          .then(function (e) {
                                              t(e);
                                          });
                            });
                        },
                        setupOutput: function (e) {
                            var t = [],
                                i = this.container.getAttribute("data-recent-count");
                            if (
                                (Object.keys(e).forEach(
                                    function (i) {
                                        if (!e[i]) return;
                                        var s = JSON.parse(e[i]);
                                        if (s.handle === this.handle) return;
                                        if (void 0 === s.handle) return;
                                        0;
                                        (s.url = theme.recentlyViewed.recent[s.handle]
                                            ? theme.recentlyViewed.recent[s.handle].url
                                            : s.url),
                                            (s.image_responsive_url = theme.Images.buildImagePath(s.featured_image)),
                                            (s.image_responsive_urls = theme.Images.buildImagePath(
                                                s.featured_image,
                                                [180, 360, 540, 720, 900]
                                            )),
                                            (s.image_aspect_ratio = theme.recentlyViewed.recent[s.handle].aspectRatio);
                                        var n = s.variants[0];
                                        if (n && n.unit_price) {
                                            var o = "";
                                            n.unit_price_measurement &&
                                                (1 != n.unit_price_measurement.reference_value &&
                                                    (o += n.unit_price_measurement.reference_value + " "),
                                                (o += n.unit_price_measurement.reference_unit)),
                                                (s.unit_price = theme.Currency.formatMoney(n.unit_price)),
                                                "" != o && (s.unit_price += "/" + o);
                                        }
                                        t.unshift(s);
                                    }.bind(this)
                                ),
                                0 !== t.length)
                            ) {
                                var s = theme.buildProductGridItem(
                                    t.slice(0, i),
                                    this.gridItemWidth,
                                    this.rowOf,
                                    this.imageSizes
                                );
                                (this.outputContainer.innerHTML = s), AOS && AOS.refreshHard();
                            } else this.container.classList.add("hide");
                        },
                        captureProductDetails: function (e) {
                            for (var t = 0; t < e.length; t++) {
                                var i = e[t];
                                theme.recentlyViewed.productInfo[i.handle] = i;
                            }
                            theme.config.hasSessionStorage &&
                                sessionStorage.setItem(
                                    "recent-products",
                                    JSON.stringify(theme.recentlyViewed.productInfo)
                                );
                        },
                        onUnload: function () {
                            e = !1;
                        },
                    })),
                    t
                );
            })()),
            (theme.Testimonials = (function () {
                var e = { adaptiveHeight: !0, avoidReflow: !0, pageDots: !0, prevNextButtons: !1 };
                function t(e) {
                    (this.container = e), this.timeout;
                    var t = e.getAttribute("data-section-id");
                    (this.slideshow = e.querySelector("#Testimonials-" + t)),
                        (this.namespace = ".testimonial-" + t),
                        this.slideshow &&
                            theme.initWhenVisible({
                                element: this.container,
                                callback: this.init.bind(this),
                                threshold: 600,
                            });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                                this.slideshow.dataset.count > 2 &&
                                    (this.timeout = setTimeout(
                                        function () {
                                            this.flickity.goToSlide(1);
                                        }.bind(this),
                                        1e3
                                    ));
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId),
                                i = parseInt(t.dataset.index);
                            clearTimeout(this.timeout),
                                this.flickity &&
                                    "function" == typeof this.flickity.pause &&
                                    (this.flickity.goToSlide(i), this.flickity.pause());
                        },
                        onBlockDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                    })),
                    t
                );
            })()),
            (theme.isStorageSupported = function (e) {
                if (window.self !== window.top) return !1;
                var t,
                    i = "test";
                "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
                try {
                    return t.setItem(i, "1"), t.removeItem(i), !0;
                } catch (e) {
                    return !1;
                }
            }),
            (theme.reinitProductGridItem = function (e) {
                AOS && AOS.refreshHard(),
                    document.documentElement.classList.contains("modal-open") || theme.initQuickShop(),
                    theme.collapsibles.init();
            }),
            (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
            (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
            AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
            theme.config.hasLocalStorage &&
                ((theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent")),
                theme.recentlyViewed.localStorage &&
                    (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage))),
            (theme.recentlyViewed.productInfo =
                theme.config.hasSessionStorage && sessionStorage["recent-products"]
                    ? JSON.parse(sessionStorage["recent-products"])
                    : {}),
            (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
            matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
                e.matches
                    ? ((theme.config.bpSmall = !0), document.dispatchEvent(new CustomEvent("matchSmall")))
                    : ((theme.config.bpSmall = !1), document.dispatchEvent(new CustomEvent("unmatchSmall")));
            }),
            (theme.initGlobals = function () {
                theme.collapsibles.init(), theme.videoModal();
            }),
            (c = function () {
                if (
                    ((theme.sections = new theme.Sections()),
                    theme.sections.register("slideshow-section", theme.SlideshowSection),
                    theme.sections.register("header", theme.HeaderSection),
                    theme.sections.register("product", theme.Product),
                    theme.sections.register("blog", theme.Blog),
                    theme.sections.register("password-header", theme.PasswordHeader),
                    theme.sections.register("photoswipe", theme.Photoswipe),
                    theme.sections.register("background-image", theme.BackgroundImage),
                    theme.sections.register("testimonials", theme.Testimonials),
                    theme.sections.register("video-section", theme.VideoSection),
                    theme.sections.register("map", theme.Maps),
                    theme.sections.register("footer-section", theme.FooterSection),
                    theme.sections.register("store-availability", theme.StoreAvailability),
                    theme.sections.register("recently-viewed", theme.RecentlyViewed),
                    theme.sections.register("newsletter-popup", theme.NewsletterPopup),
                    theme.sections.register("collection-header", theme.CollectionHeader),
                    theme.sections.register("collection-grid", theme.Collection),
                    theme.initGlobals(),
                    theme.initQuickShop(),
                    theme.rteInit(),
                    document.body.classList.contains("template-cart"))
                ) {
                    var e = document.getElementById("CartPageForm");
                    e && new theme.CartForm(e);
                }
                theme.settings.isCustomerTemplate && theme.customerTemplates(),
                    document.dispatchEvent(new CustomEvent("page:loaded"));
            }),
            "loading" != document.readyState ? c() : document.addEventListener("DOMContentLoaded", c);
    })();
